/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:49 GMT
 *
 */

import PaletteIconArrowRight from '@telus-uds/palette-allium/build/rn/icons/ArrowRight'
import PaletteIconStatusWarning from '@telus-uds/palette-allium/build/rn/icons/StatusWarning'
import PaletteIconStatusError from '@telus-uds/palette-allium/build/rn/icons/StatusError'
import PaletteIconChevronRight from '@telus-uds/palette-allium/build/rn/icons/ChevronRight'
import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
import PaletteIconCheckbold from '@telus-uds/palette-allium/build/rn/icons/Checkbold'
import PaletteIconPause from '@telus-uds/palette-allium/build/rn/icons/Pause'
import PaletteIconPlayVideo from '@telus-uds/palette-allium/build/rn/icons/PlayVideo'
import PaletteIconArrowLeft from '@telus-uds/palette-allium/build/rn/icons/ArrowLeft'
import PaletteIconAndroidEN from '@telus-uds/palette-allium/build/rn/icons/AndroidEN'
import PaletteIconAndroidFR from '@telus-uds/palette-allium/build/rn/icons/AndroidFR'
import PaletteIconIOSEN from '@telus-uds/palette-allium/build/rn/icons/IOSEN'
import PaletteIconIOSFR from '@telus-uds/palette-allium/build/rn/icons/IOSFR'
import PaletteIconStatusSuccess from '@telus-uds/palette-allium/build/rn/icons/StatusSuccess'
import PaletteIconClose from '@telus-uds/palette-allium/build/rn/icons/Close'
import PaletteIconAdd from '@telus-uds/palette-allium/build/rn/icons/Add'
import PaletteIconSubtract from '@telus-uds/palette-allium/build/rn/icons/Subtract'
import PaletteIconExpand from '@telus-uds/palette-allium/build/rn/icons/Expand'
import PaletteIconChevronLeft from '@telus-uds/palette-allium/build/rn/icons/ChevronLeft'
import PaletteIconBulletFill from '@telus-uds/palette-allium/build/rn/icons/BulletFill'
import PaletteIconStatusInfo from '@telus-uds/palette-allium/build/rn/icons/StatusInfo'
import PaletteIconTagFilled from '@telus-uds/palette-allium/build/rn/icons/TagFilled'
import PaletteIconTimes from '@telus-uds/palette-allium/build/rn/icons/Times'
import PaletteIconSearchBold from '@telus-uds/palette-allium/build/rn/icons/SearchBold'
import PaletteIconPlaySolid from '@telus-uds/palette-allium/build/rn/icons/PlaySolid'
import PaletteIconQuoteLeft from '@telus-uds/palette-allium/build/rn/icons/QuoteLeft'
import PaletteIconQuoteLeftArrow from '@telus-uds/palette-allium/build/rn/icons/QuoteLeftArrow'
import PaletteIconAmex from '@telus-uds/palette-allium/build/rn/icons/Amex'
import PaletteIconCreditCard from '@telus-uds/palette-allium/build/rn/icons/CreditCard'
import PaletteIconMasterCard from '@telus-uds/palette-allium/build/rn/icons/MasterCard'
import PaletteIconInvisible from '@telus-uds/palette-allium/build/rn/icons/Invisible'
import PaletteIconVisible from '@telus-uds/palette-allium/build/rn/icons/Visible'
import PaletteIconVisa from '@telus-uds/palette-allium/build/rn/icons/Visa'
import PaletteIconQuestion from '@telus-uds/palette-allium/build/rn/icons/Question'
import PaletteIconReplay from '@telus-uds/palette-allium/build/rn/icons/Replay'
import PaletteIconClosedCaptions from '@telus-uds/palette-allium/build/rn/icons/ClosedCaptions'
import PaletteIconFullscreenExpand from '@telus-uds/palette-allium/build/rn/icons/FullscreenExpand'
import PaletteIconFullscreenMinimize from '@telus-uds/palette-allium/build/rn/icons/FullscreenMinimize'
import PaletteIconSettingsSolid from '@telus-uds/palette-allium/build/rn/icons/SettingsSolid'
import PaletteIconMuted from '@telus-uds/palette-allium/build/rn/icons/Muted'
import PaletteIconUnmuted from '@telus-uds/palette-allium/build/rn/icons/Unmuted'
const theme = {
  components: {
    ActionCard: {
      appearances: {
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { actionIconTranslate: 4 } },
        {
          if: { validation: 'warning' },
          tokens: {
            actionIconMarginLeft: 8,
            backgroundColor: '#fff9ee',
            borderColor: '#c77539',
            statusIcon: PaletteIconStatusWarning,
            statusIconColor: '#c77539'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            actionIconMarginLeft: 8,
            backgroundColor: '#fff6f8',
            borderColor: '#e12339',
            statusIcon: PaletteIconStatusError,
            statusIconColor: '#e12339'
          }
        }
      ],
      tokens: {
        actionIcon: PaletteIconArrowRight,
        actionIconColor: '#414547',
        actionIconMarginBottom: 8,
        actionIconMarginLeft: 0,
        actionIconMarginRight: 0,
        actionIconMarginTop: 8,
        actionIconTranslate: 4,
        backgroundColor: null,
        borderColor: null,
        borderRadius: null,
        borderWidth: null,
        contentFontColor: '#414547',
        contentFontName: 'HNforTELUSSA',
        contentFontSize: 16,
        contentFontWeight: '400',
        contentLineHeight: 1.25,
        contentMarginBottom: 8,
        contentMarginLeft: 0,
        contentMarginRight: 0,
        contentMarginTop: 0,
        iconBackgroundColor: 'rgba(0, 0, 0, 0.05)',
        iconColor: '#414547',
        iconMarginBottom: 0,
        iconMarginLeft: 0,
        iconMarginRight: 8,
        iconMarginTop: 0,
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16,
        statusIcon: null,
        statusIconColor: null,
        titleFontColor: '#414547',
        titleFontName: 'HNforTELUSSA',
        titleFontSize: 16,
        titleFontWeight: '700',
        titleLineHeight: 1.5,
        titleMarginBottom: 8,
        titleMarginLeft: 0,
        titleMarginRight: 8,
        titleMarginTop: 8
      }
    },
    ActivityIndicator: {
      appearances: {
        dots: { type: 'variant', values: [ true ] },
        size: {
          description: 'used for full-screen spinners',
          type: 'variant',
          values: [ 'large', 'small' ]
        },
        style: { type: 'variant', values: [ 'dots' ] }
      },
      rules: [
        {
          if: { size: 'large' },
          tokens: { dotSize: 12, size: 48, thickness: 4 }
        },
        {
          if: { size: 'small' },
          tokens: { dotSize: 6, size: 24, thickness: 3 }
        }
      ],
      tokens: {
        color: '#2b8000',
        dotSize: 12,
        fullScreenOverlayBackground: 'rgba(255, 255, 255, 0.97)',
        indicatorBackgroundColor: '#e3f6d1',
        size: 48,
        thickness: 4
      }
    },
    Autocomplete: {
      appearances: {},
      rules: [],
      tokens: { color: '#414547', maxHeight: '100%', overflowY: 'visible' }
    },
    Badge: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        inverse: { type: 'variant', values: [ true ] },
        outline: { type: 'variant', values: [ true ] },
        purpose: { type: 'variant', values: [ 'offer', 'editorial', 'subtle' ] },
        size: { type: 'variant', values: [ 'compact' ] }
      },
      rules: [
        {
          if: { inverse: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#ffffff',
            color: '#ffffff'
          }
        },
        {
          if: { outline: true },
          tokens: { backgroundColor: '#ffffff', color: '#613889' }
        },
        {
          if: { alternative: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            gradient: {
              angle: 135,
              stops: [
                { color: '#00784a', hint: 0.75, stop: 0 },
                { color: '#66cc00', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { purpose: 'subtle' },
          tokens: {
            backgroundColor: '#7c53a5',
            borderColor: '#7c53a5',
            color: '#ffffff'
          }
        },
        {
          if: { purpose: 'offer' },
          tokens: {
            borderWidth: 0,
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            },
            paddingBottom: 4,
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 4
          }
        },
        {
          if: { purpose: 'editorial' },
          tokens: {
            backgroundColor: '#676e73',
            borderColor: '#676e73',
            color: '#ffffff'
          }
        },
        {
          if: { outline: true, purpose: 'subtle' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#7c53a5',
            color: '#7c53a5'
          }
        },
        {
          if: { outline: true, purpose: 'editorial' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#676e73',
            color: '#676e73'
          }
        },
        {
          if: { outline: true, purpose: 'offer' },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 2,
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            },
            paddingBottom: 2,
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 2
          }
        },
        {
          if: { size: 'compact' },
          tokens: {
            fontSize: 12,
            paddingBottom: 0,
            paddingLeft: 3,
            paddingRight: 3,
            paddingTop: 0
          }
        },
        {
          if: { purpose: 'offer', size: 'compact' },
          tokens: {
            fontSize: 12,
            paddingBottom: 2,
            paddingLeft: 3,
            paddingRight: 3,
            paddingTop: 2
          }
        }
      ],
      tokens: {
        backgroundColor: '#613889',
        borderColor: '#613889',
        borderRadius: 4,
        borderWidth: 2,
        color: '#ffffff',
        fontName: 'HNforTELUSSA',
        fontSize: 12,
        fontWeight: '700',
        gradient: null,
        paddingBottom: 2,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 2
      }
    },
    BlockQuote: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm', 'md' ] },
          tokens: {
            titleHeadingFontName: 'HNforTELUSSA',
            titleHeadingFontSize: 24,
            titleHeadingFontWeight: '400',
            titleHeadingLineHeight: 1.33333333333
          }
        }
      ],
      tokens: {
        backgroundGradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        },
        color: '#414547',
        linkFontName: 'HNforTELUSSA',
        linkFontSize: 16,
        linkFontWeight: '700',
        linkLineHeight: 1.5,
        marginBottom: 16,
        paddingBottom: 16,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 16,
        titleFontName: 'HNforTELUSSA',
        titleFontSize: 20,
        titleFontWeight: '400',
        titleHeadingFontName: 'HNforTELUSSA',
        titleHeadingFontSize: 28,
        titleHeadingFontWeight: '400',
        titleHeadingLineHeight: 1.28571428571,
        titleLineHeight: 1.6,
        width: 2
      }
    },
    Box: {
      appearances: {
        background: {
          description: 'Background colour of box. Transparent if not specified.',
          type: 'variant',
          values: [
            'lightest',         'lighter',
            'light',            'dark',
            'darker',           'darkest',
            'critical',         'danger',
            'warning',          'positive',
            'brand',            'white',
            'black',            'purpleGradient',
            'greenGradient',    'neutralGradient',
            'brandGradient',    'featurePrimary',
            'featureSecondary', 'featureNeutral',
            'featureBrand'
          ]
        }
      },
      rules: [
        {
          if: { background: 'lightest' },
          tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
        },
        {
          if: { background: 'lighter' },
          tokens: { backgroundColor: '#fafafa', borderColor: '#fafafa' }
        },
        {
          if: { background: 'light' },
          tokens: { backgroundColor: '#f4f4f7', borderColor: '#f4f4f7' }
        },
        {
          if: { background: 'dark' },
          tokens: { backgroundColor: '#414547', borderColor: '#414547' }
        },
        {
          if: { background: 'darker' },
          tokens: { backgroundColor: '#2c2e30', borderColor: '#2c2e30' }
        },
        {
          if: { background: 'darkest' },
          tokens: { backgroundColor: '#000000', borderColor: '#000000' }
        },
        {
          if: { background: 'critical' },
          tokens: { backgroundColor: '#c12335', borderColor: '#c12335' }
        },
        {
          if: { background: 'danger' },
          tokens: { backgroundColor: '#fff6f8', borderColor: '#fff6f8' }
        },
        {
          if: { background: 'warning' },
          tokens: { backgroundColor: '#fff9ee', borderColor: '#fff9ee' }
        },
        {
          if: { background: 'positive' },
          tokens: { backgroundColor: '#f4f9f2', borderColor: '#f4f9f2' }
        },
        {
          if: { background: 'brand' },
          tokens: { backgroundColor: '#4b286d', borderColor: '#4b286d' }
        },
        {
          if: { background: 'white' },
          tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
        },
        {
          if: { background: 'black' },
          tokens: { backgroundColor: '#000000', borderColor: '#000000' }
        },
        {
          if: { background: 'brandGradient' },
          tokens: {
            backgroundColor: null,
            borderColor: null,
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#613889', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { background: 'greenGradient' },
          tokens: {
            backgroundColor: null,
            borderColor: null,
            gradient: {
              angle: 135,
              stops: [
                { color: '#00784a', hint: 0.75, stop: 0 },
                { color: '#66cc00', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { background: 'neutralGradient' },
          tokens: {
            backgroundColor: null,
            borderColor: null,
            gradient: {
              angle: 180,
              stops: [
                { color: '#ffffff', stop: 0 },
                { color: '#f4f4f7', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { background: 'purpleGradient' },
          tokens: {
            backgroundColor: null,
            borderColor: null,
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { background: 'featurePrimary' },
          tokens: {
            backgroundColor: null,
            borderColor: null,
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { background: 'featureSecondary' },
          tokens: {
            backgroundColor: null,
            borderColor: null,
            gradient: {
              angle: 135,
              stops: [
                { color: '#00784a', hint: 0.75, stop: 0 },
                { color: '#66cc00', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { background: 'featureNeutral' },
          tokens: {
            backgroundColor: null,
            borderColor: null,
            gradient: {
              angle: 180,
              stops: [
                { color: '#ffffff', stop: 0 },
                { color: '#f4f4f7', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { background: 'featureBrand' },
          tokens: {
            backgroundColor: null,
            borderColor: null,
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#613889', stop: 1 }
              ],
              type: 'linear'
            }
          }
        }
      ],
      tokens: {
        backgroundColor: null,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderColor: null,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderWidth: 0,
        gradient: null
      }
    },
    Breadcrumbs: {
      appearances: { inverse: { type: 'variant', values: [ true ] } },
      rules: [
        {
          if: { inverse: true },
          tokens: {
            color: '#ffffff',
            currentColor: '#ffffff',
            iconColor: '#b2b9bf'
          }
        }
      ],
      tokens: {
        color: '#676e73',
        currentColor: '#414547',
        fontName: 'HNforTELUSSA',
        fontSize: 12,
        fontWeight: '500',
        icon: PaletteIconChevronRight,
        iconColor: '#b2b9bf',
        iconContainerSize: 16,
        iconPadding: 4,
        iconSize: 16,
        lineHeight: 1.33333333333,
        listItemPadding: 0
      }
    },
    Button: {
      appearances: {
        danger: {
          description: 'Indicates a user action that is destructive and will result in loss of information or cause significant monetary charges. Limit the use of the danger button whenever possible.',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        inverse: {
          description: 'Use inverse buttons on darker backgrounds. High and low priority buttons, and danger buttons, are available in inverse.',
          type: 'variant',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        priority: {
          description: 'Indicates the importance of the call-to-action. Limit the amount of high priority buttons on a page to prioritize meaningful user flows. Low priority styles are applied by default.',
          type: 'variant',
          values: [ 'high', 'low' ]
        },
        size: { type: 'variant', values: [ 'small' ] },
        text: {
          description: 'Text variant visually deprioritize the button styles',
          type: 'variant',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        width: {
          description: 'Available in default, full-width or responsive. Default-width expands based on content. Full-width expands to width of the container. Responsive automatically applies full-width when is displayed on the XS viewport.',
          type: 'variant',
          values: [ 'full', 'responsive' ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            borderBottomWidth: 3,
            borderLeftWidth: 3,
            borderRightWidth: 3,
            borderTopWidth: 3
          }
        },
        {
          if: { priority: 'high' },
          tokens: {
            backgroundColor: '#2b8000',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0,
            color: '#ffffff'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#163e06',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#ffffff'
          }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#2b8000' }
        },
        {
          if: { inverse: true },
          tokens: {
            backgroundColor: null,
            borderColor: '#ffffff',
            color: '#ffffff'
          }
        },
        {
          if: { hover: true, priority: 'high' },
          tokens: { backgroundColor: '#1f5c09' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { outerBorderColor: '#163e06' }
        },
        {
          if: { inverse: true, priority: 'high' },
          tokens: { backgroundColor: '#ffffff', color: '#414547' }
        },
        {
          if: { hover: true, inverse: true, priority: 'high' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.8)' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#414547'
          }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { outerBorderColor: '#ffffff' }
        },
        {
          if: { danger: true, priority: null },
          tokens: { borderColor: '#e12339', color: '#e12339' }
        },
        {
          if: { danger: true, inverse: true, priority: null },
          tokens: { backgroundColor: '#ffffff' }
        },
        {
          if: { danger: true, focus: true, priority: null },
          tokens: { outerBorderColor: '#e12339' }
        },
        {
          if: { danger: true, pressed: true, priority: null },
          tokens: {
            backgroundColor: '#c12335',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#ffffff'
          }
        },
        {
          if: { danger: true, focus: true, pressed: true, priority: null },
          tokens: { outerBorderColor: '#c12335' }
        },
        { if: { width: 'full' }, tokens: { width: '100%' } },
        {
          if: { viewport: [ 'xs' ], width: 'responsive' },
          tokens: { width: '100%' }
        },
        {
          if: { size: 'small' },
          tokens: { minWidth: 0, paddingBottom: 4, paddingTop: 4 }
        },
        {
          description: 'Buttons should not be disabled or set as inactive. Use inline (on blur) error messaging to provide feedback when the form is invalid. In exceptional instances where disabled buttons are needed, it must be clear to the user why the button is disabled and what they need to do to enable it.',
          if: { inactive: true },
          tokens: {
            backgroundColor: '#b2b9bf',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0,
            color: '#ffffff'
          }
        },
        {
          if: { inactive: true, inverse: true },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#414547'
          }
        },
        {
          if: { text: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderWidth: null,
            minWidth: 0,
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            paddingLeft: 0,
            paddingRight: 0,
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, text: true },
          tokens: { textLine: 'none' }
        },
        {
          if: { priority: 'high', text: true },
          tokens: { color: '#2b8000' }
        },
        {
          if: { priority: 'low', text: true },
          tokens: { color: '#414547' }
        },
        {
          if: { focus: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            borderRadius: 0,
            color: '#2b8000',
            outerBorderColor: '#2b8000'
          }
        },
        {
          if: { hover: true, priority: 'high', text: true },
          tokens: { color: '#1f5c09' }
        },
        {
          if: { hover: true, priority: null, text: true },
          tokens: { color: '#1f5c09' }
        },
        {
          if: { hover: true, priority: 'low', text: true },
          tokens: { color: '#414547' }
        },
        {
          if: { danger: true, hover: true, text: true },
          tokens: { color: '#c12335' }
        },
        {
          if: { pressed: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#163e06',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            textLine: 'none'
          }
        },
        {
          if: { focus: true, pressed: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#163e06',
            outerBorderColor: '#163e06',
            textLine: 'none'
          }
        },
        {
          if: { inactive: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#b2b9bf',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            textLine: 'none'
          }
        },
        {
          if: { inverse: true, text: true },
          tokens: { borderRadius: 0, color: '#ffffff' }
        },
        {
          if: { focus: true, inverse: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            outerBorderColor: '#ffffff'
          }
        },
        {
          if: { focus: true, inverse: true, pressed: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#b2b9bf',
            outerBorderColor: '#b2b9bf'
          }
        },
        {
          if: { inactive: true, inverse: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#b2b9bf',
            outerBorderColor: 'rgba(0, 0, 0, 0)'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderBottomWidth: 1,
        borderColor: '#2b8000',
        borderLeftWidth: 1,
        borderRadius: 32,
        borderRightWidth: 1,
        borderTopWidth: 1,
        borderWidth: 1,
        color: '#2b8000',
        flex: 0,
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '700',
        height: null,
        icon: null,
        iconSize: 24,
        iconSpace: 1,
        lineHeight: 1.5,
        minWidth: 144,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 12,
        shadow: null,
        textAlign: 'center',
        textLine: 'none',
        textLineStyle: 'solid',
        width: null
      }
    },
    ButtonDropdown: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        open: {
          description: 'Applies when a ButtonDropdown is open.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        size: { type: 'variant', values: [ 'default', 'small' ] },
        width: { type: 'variant', values: [ 'full' ] }
      },
      rules: [
        { if: { open: true }, tokens: { icon: PaletteIconCaretUp } },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#676e73',
            color: '#414547',
            outerBorderColor: '#676e73',
            outerBorderGap: 2,
            outerBorderWidth: 2
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#676e73',
            color: '#ffffff',
            iconBackground: '#414547',
            iconColor: '#ffffff'
          }
        },
        { if: { hover: true }, tokens: { borderWidth: 3 } },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#ffffff',
            borderWidth: 0,
            color: '#b2b9bf',
            iconBackground: '#f4f4f7',
            iconColor: '#b2b9bf'
          }
        },
        {
          if: { focus: true, pressed: true, selected: true },
          tokens: { outerBorderGap: 2, outerBorderWidth: 2 }
        },
        {
          if: { size: 'small' },
          tokens: {
            descriptionLineHeight: 1,
            iconSize: 20,
            paddingBottom: 4,
            paddingTop: 4
          }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderRadius: 45,
        borderWidth: 1,
        color: '#676e73',
        descriptionFontName: 'HNforTELUSSA',
        descriptionFontSize: 16,
        descriptionFontWeight: '400',
        descriptionLineHeight: 1.25,
        descriptionTextPaddingBottom: 4,
        dividerColor: '#e3e6e8',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '700',
        icon: PaletteIconCaretDown,
        iconAlignSelf: 'center',
        iconBackground: 'rgba(0, 0, 0, 0)',
        iconBorderRadius: 32,
        iconColor: '#414547',
        iconPadding: 2,
        iconPosition: 'right',
        iconSize: 20,
        iconSpace: 1,
        iconTranslateX: 0,
        iconTranslateY: 0,
        leadIcon: null,
        leadIconBackgroundColor: '#f4f4f7',
        leadIconBorderRadius: 45,
        leadIconColor: '#414547',
        leadIconContainerPaddingBottom: 0,
        leadIconContainerPaddingLeft: 0,
        leadIconContainerPaddingRight: 0,
        leadIconContainerPaddingTop: 0,
        leadIconPadding: 4,
        leadIconSize: 24,
        lineHeight: 1.5,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12,
        shadow: null,
        subtitleColor: '#676e73',
        textAlign: 'center',
        textPaddingLeft: 8,
        textPaddingRight: 8,
        width: null
      }
    },
    ButtonGroup: {
      appearances: {
        style: {
          description: 'Configure `style` variant for `ButtonGroup`',
          type: 'variant',
          values: [ 'contained' ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        width: {
          description: 'Available in default, responsive or equal. Default-width expands based on content. Responsive automatically applies full-width when is displayed on the XS viewport, equal divide the available width equally among `ButtonGroup`',
          type: 'variant',
          values: [ 'responsive', 'equal' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { gap: 3, space: 3 }
        },
        {
          if: { viewport: [ 'xs' ], width: 'responsive' },
          tokens: { alignItems: 'stretch', direction: 'column' }
        },
        {
          if: { style: 'contained' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: 99,
            padding: 8,
            space: 2
          }
        },
        {
          if: {
            style: 'contained',
            viewport: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
          },
          tokens: { borderRadius: 28 }
        }
      ],
      tokens: {
        alignItems: 'center',
        backgroundColor: null,
        borderRadius: 0,
        direction: 'row',
        fieldSpace: 2,
        flexGrow: 0,
        flexShrink: 0,
        gap: 2,
        justifyContent: 'flex-start',
        padding: 0,
        space: 2
      }
    },
    ButtonGroupItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        iconPosition: {
          description: 'Theme styles to be applied to icon links depending on where the icon is in relation to the link text',
          type: 'state',
          values: [ 'left', 'right', 'inline' ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        size: { type: 'variant', values: [ 'small' ] },
        style: {
          description: 'Configure `style` variant for `ButtonGroupItem`',
          type: 'variant',
          values: [ 'contained' ]
        },
        width: {
          description: 'Available in default, responsive or equal. Default-width expands based on content. Responsive automatically applies full-width when is displayed on the XS viewport, equal divide the available width equally among `ButtonGroup`',
          type: 'variant',
          values: [ 'responsive', 'equal' ]
        }
      },
      rules: [
        { if: { width: 'equal' }, tokens: { width: '100%' } },
        {
          if: { size: 'small' },
          tokens: { height: 32, paddingBottom: 4, paddingTop: 4 }
        },
        { if: { hover: true }, tokens: { borderWidth: 3 } },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#676e73',
            borderColor: '#676e73',
            color: '#ffffff'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#676e73',
            borderColor: '#676e73',
            borderWidth: 0,
            color: '#ffffff'
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#676e73',
            outerBorderColor: '#676e73',
            outerBorderGap: 2,
            outerBorderWidth: 2
          }
        },
        { if: { hover: true }, tokens: { borderWidth: 3 } },
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#4b286d',
            borderWidth: 0,
            color: '#ffffff'
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: { backgroundColor: '#7c53a5' }
        },
        {
          if: { pressed: true, selected: true },
          tokens: { backgroundColor: '#3f2a54' }
        },
        {
          if: { focus: true, selected: true },
          tokens: { outerBorderColor: '#4b286d' }
        },
        {
          if: { focus: true, pressed: true, selected: true },
          tokens: { outerBorderColor: '#3f2a54' }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#b2b9bf',
            borderWidth: 0,
            color: '#ffffff'
          }
        },
        { if: { iconPosition: 'right' }, tokens: { iconSpace: 1 } },
        { if: { width: 'responsive' }, tokens: { width: '100%' } },
        {
          if: { style: 'contained' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0,
            height: 40,
            paddingBottom: 8,
            paddingTop: 8
          }
        },
        {
          if: { size: 'small', style: 'contained' },
          tokens: { height: 32, paddingBottom: 6, paddingTop: 6 }
        },
        {
          if: { hover: true, style: 'contained' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#676e73',
            borderWidth: 3
          }
        },
        {
          if: { selected: true, style: 'contained' },
          tokens: {
            backgroundColor: '#4b286d',
            color: '#ffffff',
            outerBorderWidth: 0
          }
        },
        {
          if: { focus: true, style: 'contained' },
          tokens: {
            borderColor: '#676e73',
            borderWidth: 1,
            outerBorderWidth: 0
          }
        },
        {
          if: { hover: true, selected: true, style: 'contained' },
          tokens: {
            backgroundColor: '#7c53a5',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#ffffff',
            outerBorderWidth: 0
          }
        },
        {
          if: { focus: true, selected: true, style: 'contained' },
          tokens: { outerBorderColor: '#4b286d', outerBorderWidth: 2 }
        },
        {
          if: { pressed: true, style: 'contained' },
          tokens: { backgroundColor: '#3f2a54' }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderRadius: 32,
        borderWidth: 1,
        color: '#676e73',
        fontName: 'HNforTELUSSA',
        fontSize: 14,
        fontWeight: '700',
        height: 48,
        iconSize: 20,
        iconSpace: 2,
        lineHeight: 1.42857142857,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        shadow: null,
        textAlign: 'center',
        width: null
      }
    },
    Callout: {
      appearances: {
        rounded: { type: 'variant', values: [ true, false ] },
        size: { type: 'variant', values: [ 'small' ] }
      },
      rules: [
        {
          if: { size: 'small' },
          tokens: { paddingBottom: 4, paddingTop: 4 }
        },
        { if: { rounded: true }, tokens: { borderRadius: 4 } }
      ],
      tokens: {
        background: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 0,
        color: '#4b286d',
        gap: 16,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8
      }
    },
    Card: {
      appearances: {
        background: {
          type: 'variant',
          values: [ 'alternative', 'subtle', 'grid', 'feature', 'plain' ]
        },
        borderRadius: { type: 'variant', values: [ 'none', 'small', 'large' ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        interactive: { type: 'variant', values: [ true ] },
        isControl: { type: 'variant', values: [ true, false ] },
        padding: {
          type: 'variant',
          values: [ 'narrow', 'intermediate', 'compact', 'custom' ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        style: {
          type: 'variant',
          values: [
            'grid',     'light',
            'lighter',  'lightest',
            'dark',     'darker',
            'darkest',  'feature',
            'feature2', 'feature3',
            'feature4', 'warning',
            'error',    'success'
          ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { interactive: true, isControl: true },
          tokens: { borderColor: '#b2b9bf', borderWidth: 1 }
        },
        {
          if: { interactive: true, isControl: true, selected: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#4b286d',
            borderWidth: 1,
            iconBackgroundColor: '#e3e6e8',
            iconColor: '#4b286d',
            inputBackgroundColor: '#e3e6e8'
          }
        },
        {
          if: { hover: true, interactive: true, isControl: true },
          tokens: { iconColor: '#414547' }
        },
        {
          if: {
            focus: false,
            interactive: true,
            isControl: true,
            pressed: false
          },
          tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 2 }
        },
        {
          if: {
            hover: true,
            interactive: true,
            isControl: true,
            selected: true
          },
          tokens: {
            iconBackgroundColor: '#e3e6e8',
            iconColor: '#414547',
            inputBackgroundColor: '#e3e6e8'
          }
        },
        { if: { borderRadius: 'none' }, tokens: { borderRadius: 0 } },
        { if: { borderRadius: 'small' }, tokens: { borderRadius: 6 } },
        { if: { borderRadius: 'large' }, tokens: { borderRadius: 12 } },
        {
          if: { background: 'alternative' },
          tokens: { backgroundColor: '#f4f4f7' }
        },
        {
          if: { background: 'subtle' },
          tokens: { backgroundColor: '#fafafa' }
        },
        {
          if: { background: 'feature' },
          tokens: {
            borderColor: '#4b286d',
            borderWidth: 2,
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { background: 'grid' },
          tokens: { backgroundColor: '#fafafa', borderWidth: 0 }
        },
        {
          if: { background: 'plain' },
          tokens: { backgroundColor: '#ffffff', borderWidth: 0 }
        },
        {
          if: { style: 'grid' },
          tokens: { backgroundColor: '#fafafa', borderWidth: 0 }
        },
        {
          if: { style: 'light' },
          tokens: { backgroundColor: '#f4f4f7' }
        },
        {
          if: { style: 'lighter' },
          tokens: { backgroundColor: '#fafafa' }
        },
        {
          if: { style: 'lightest' },
          tokens: { backgroundColor: '#ffffff', borderWidth: 0 }
        },
        {
          if: { style: 'dark' },
          tokens: {
            backgroundColor: '#4b286d',
            backgroundGradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            },
            borderColor: '#4b286d',
            borderWidth: 1
          }
        },
        {
          if: { style: 'darker' },
          tokens: { backgroundColor: '#4b286d', borderWidth: 0 }
        },
        {
          if: { style: 'darkest' },
          tokens: { backgroundColor: '#2c2e30', borderWidth: 0 }
        },
        {
          if: { style: 'feature' },
          tokens: {
            borderColor: '#4b286d',
            borderWidth: 2,
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { style: 'feature2' },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#e3e6e8',
            borderWidth: 1
          }
        },
        {
          if: { style: 'feature3' },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#e3e6e8',
            borderWidth: 1
          }
        },
        {
          if: { style: 'feature4' },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#e3e6e8',
            borderWidth: 1
          }
        },
        {
          if: { style: 'warning' },
          tokens: {
            backgroundColor: '#fff9ee',
            borderColor: '#faca69',
            borderWidth: 1
          }
        },
        {
          if: { style: 'error' },
          tokens: {
            backgroundColor: '#ffffff',
            borderColor: '#e12339',
            borderWidth: 1
          }
        },
        {
          if: { style: 'success' },
          tokens: {
            backgroundColor: '#f4f9f2',
            borderColor: '#2b8000',
            borderWidth: 1
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 48,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 48
          }
        },
        {
          if: { interactive: true, viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 45,
            paddingLeft: 29,
            paddingRight: 29,
            paddingTop: 45
          }
        },
        {
          if: { padding: 'narrow' },
          tokens: {
            paddingBottom: 24,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 24
          }
        },
        {
          if: { interactive: true, padding: 'narrow' },
          tokens: {
            paddingBottom: 21,
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 21
          }
        },
        {
          if: { padding: 'narrow', viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 32,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 32
          }
        },
        {
          if: {
            interactive: true,
            padding: 'narrow',
            viewport: [ 'md', 'lg', 'xl' ]
          },
          tokens: {
            paddingBottom: 29,
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 29
          }
        },
        {
          if: { padding: 'intermediate' },
          tokens: {
            paddingBottom: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
          }
        },
        {
          if: { interactive: true, padding: 'intermediate' },
          tokens: {
            paddingBottom: 21,
            paddingLeft: 21,
            paddingRight: 21,
            paddingTop: 21
          }
        },
        {
          if: { padding: 'intermediate', viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 32,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 32
          }
        },
        {
          if: {
            interactive: true,
            padding: 'intermediate',
            viewport: [ 'md', 'lg', 'xl' ]
          },
          tokens: {
            paddingBottom: 29,
            paddingLeft: 29,
            paddingRight: 29,
            paddingTop: 29
          }
        },
        {
          if: { padding: 'compact' },
          tokens: {
            paddingBottom: 16,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 16
          }
        },
        {
          if: { interactive: true, padding: 'compact' },
          tokens: {
            paddingBottom: 13,
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 13
          }
        },
        {
          if: { padding: 'custom' },
          tokens: {
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0
          }
        },
        {
          if: { interactive: true },
          tokens: { backgroundColor: 'transparent' }
        },
        {
          if: {
            focus: false,
            interactive: true,
            isControl: false,
            pressed: false
          },
          tokens: { borderColor: '#ffffff', borderWidth: 2 }
        },
        {
          if: { focus: false, interactive: true, pressed: false },
          tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 2 }
        },
        {
          if: { hover: true, interactive: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderColor: 'transparent'
          }
        },
        {
          if: { focus: true, interactive: true },
          tokens: { borderColor: '#4b286d', borderWidth: 2 }
        },
        {
          if: { interactive: true, pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderColor: '#e3e6e8',
            borderWidth: 2
          }
        },
        {
          if: { interactive: true, isControl: false, selected: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#4b286d',
            borderWidth: 1
          }
        },
        {
          if: { hover: true, interactive: true, style: 'dark' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
        },
        {
          if: { hover: true, interactive: true, style: 'darker' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
        },
        {
          if: { hover: true, interactive: true, style: 'darkest' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
        },
        {
          if: { interactive: true, pressed: true, style: 'dark' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
        },
        {
          if: { interactive: true, pressed: true, style: 'darker' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
        },
        {
          if: { interactive: true, pressed: true, style: 'darkest' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        backgroundGradient: null,
        borderColor: '#e3e6e8',
        borderRadius: 6,
        borderWidth: 1,
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 1,
        contentJustifyContent: 'flex-start',
        flex: 1,
        gradient: null,
        icon: PaletteIconCheckbold,
        iconBackgroundColor: '#f4f4f7',
        iconColor: '#4b286d',
        iconSize: 20,
        inputBackgroundColor: '#f4f4f7',
        inputBorderColor: 'rgba(0, 0, 0, 0)',
        inputBorderRadius: 4,
        inputBorderWidth: 0,
        inputHeight: 32,
        inputShadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: true,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        },
        inputWidth: 32,
        maxHeight: '100%',
        minWidth: null,
        overflowY: 'visible',
        paddingBottom: 32,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 32,
        shadow: null
      }
    },
    CardGroup: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: { direction: 'row', space: 5 }
        },
        {
          if: { viewport: [ 'xs', 'sm', 'md' ] },
          tokens: { direction: 'column', fieldSpace: 3, space: 3 }
        }
      ],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        direction: 'column',
        fieldSpace: 3,
        outlineOffset: 8,
        outlineWidth: 1,
        paddingBottom: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 24,
        showIcon: true,
        space: 3
      }
    },
    Carousel: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: { showPanelTabs: false, showPreviousNextNavigation: false }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        iconBackgroundColor: '#ffffff',
        nextIcon: PaletteIconArrowRight,
        pauseIcon: PaletteIconPause,
        playIcon: PaletteIconPlayVideo,
        previousIcon: PaletteIconArrowLeft,
        showPanelNavigation: true,
        showPanelTabs: true,
        showPreviousNextNavigation: true,
        spaceBetweenSlideAndPanelNavigation: 32,
        spaceBetweenSlideAndPreviousNextNavigation: 24,
        stepTrackerCurrentBackgroundColor: null
      }
    },
    CarouselTabsPanelItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            borderBottomColor: '#2b8000',
            borderBottomWidth: 2,
            color: '#2b8000'
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderBottomColor: '#2b8000',
            borderBottomWidth: 4,
            color: '#2b8000'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            borderBottomColor: '#1f5c09',
            borderBottomWidth: 2,
            color: '#1f5c09'
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { borderBottomWidth: 4 }
        },
        {
          if: { inactive: true },
          tokens: {
            borderBottomColor: '#676e73',
            borderBottomWidth: 4,
            color: '#676e73'
          }
        },
        {
          if: { selected: true },
          tokens: {
            borderBottomColor: '#676e73',
            borderBottomWidth: 4,
            color: '#676e73',
            fontName: 'HNforTELUSSA',
            fontWeight: '400'
          }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          if: { hover: true, inverse: true },
          tokens: {
            borderBottomColor: '#ffffff',
            borderBottomWidth: 2,
            color: '#ffffff'
          }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            borderBottomColor: '#676e73',
            borderBottomWidth: 2,
            color: '#676e73'
          }
        },
        {
          if: { focus: true, inverse: true },
          tokens: {
            borderBottomColor: '#ffffff',
            borderBottomWidth: 4,
            color: '#ffffff'
          }
        },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: {
            borderBottomColor: '#676e73',
            borderBottomWidth: 4,
            color: '#676e73'
          }
        },
        {
          if: { inverse: true, selected: true },
          tokens: {
            borderBottomColor: '#ffffff',
            borderBottomWidth: 4,
            color: '#ffffff',
            fontName: 'HNforTELUSSA',
            fontWeight: '700'
          }
        }
      ],
      tokens: {
        alignItems: 'flex-start',
        borderBottomColor: 'transparent',
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        color: '#414547',
        flex: 1,
        fontName: 'HNforTELUSSA',
        fontScaleCap: 64,
        fontSize: 14,
        fontWeight: '400',
        justifyContent: 'flex-start',
        letterSpacing: 0,
        lineHeight: 1.45,
        paddingBottom: 16,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0
      }
    },
    CarouselThumbnail: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: { alignItems: 'flex-start', size: 32 }
        },
        { if: { hover: true }, tokens: { borderColor: '#2b8000' } },
        {
          if: { focus: true },
          tokens: { borderColor: '#2b8000', borderWidth: 2 }
        },
        {
          if: { pressed: true },
          tokens: { borderColor: '#1f5c09', borderWidth: 2 }
        }
      ],
      tokens: {
        alignItems: 'center',
        borderColor: '#e3e6e8',
        borderRadius: 4,
        borderWidth: 1,
        containerPaddingTop: 24,
        margin: 4,
        padding: 8,
        selectedBorderColor: '#676e73',
        selectedBorderWidth: 2,
        size: 56
      }
    },
    Checkbox: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { error: true },
          tokens: { inputBorderColor: '#e12339' }
        },
        {
          if: { focus: true },
          tokens: { inputBorderColor: '#7c53a5', inputBorderWidth: 3 }
        },
        {
          if: { inactive: true },
          tokens: {
            descriptionFontColor: '#676e73',
            iconBackgroundColor: '#e3e6e8',
            iconColor: '#676e73',
            inputBackgroundColor: '#e3e6e8',
            inputBorderColor: 'rgba(0, 0, 0, 0)',
            labelColor: '#676e73'
          }
        },
        {
          if: { hover: true },
          tokens: { inputOutlineColor: '#e3e6e8', inputOutlineWidth: 2 }
        },
        {
          if: { checked: true, focus: true },
          tokens: {
            inputBorderColor: '#ffffff',
            inputBorderWidth: 2,
            inputOutlineColor: '#7c53a5',
            inputOutlineWidth: 3
          }
        }
      ],
      tokens: {
        containerBackgroundColor: 'rgba(0, 0, 0, 0)',
        descriptionFontColor: '#414547',
        descriptionFontName: 'HNforTELUSSA',
        descriptionFontSize: 14,
        descriptionFontWeight: '400',
        descriptionLineHeight: 1.42857142857,
        descriptionMarginLeft: null,
        feedbackMarginBottom: 0,
        feedbackMarginTop: 2,
        feedbackPosition: 'bottom',
        icon: PaletteIconCheckbold,
        iconBackgroundColor: '#7c53a5',
        iconColor: '#ffffff',
        iconSize: 16,
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#676e73',
        inputBorderRadius: 4,
        inputBorderWidth: 1,
        inputHeight: 20,
        inputOutlineColor: null,
        inputOutlineOffset: 0,
        inputOutlineWidth: 0,
        inputShadow: null,
        inputWidth: 20,
        labelColor: '#414547',
        labelFontName: 'HNforTELUSSA',
        labelFontSize: 16,
        labelFontWeight: '400',
        labelLineHeight: 1.5,
        labelMarginLeft: 8
      }
    },
    CheckboxCard: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: {
            fontSize: 24,
            lineHeight: 1.33333333333,
            paddingBottom: 24,
            paddingLeft: 16,
            paddingRight: 24,
            paddingTop: 16
          }
        },
        {
          if: { hover: true },
          tokens: {
            borderColor: '#676e73',
            checkboxOuterBorderColor: '#e3e6e8',
            checkboxOuterBorderWidth: 2,
            outerBorderColor: '#e3e6e8'
          }
        },
        {
          if: { focus: true },
          tokens: {
            checkboxInputBorderColor: '#7c53a5',
            checkboxInputBorderWidth: 3,
            outerBorderColor: '#676e73',
            outerBorderGap: 2
          }
        },
        {
          description: 'Pressed state matches hover state plus light grey background',
          if: { pressed: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#676e73',
            checkboxInputBorderColor: '#676e73',
            checkboxInputBorderWidth: 1,
            checkboxOuterBorderColor: '#e3e6e8',
            checkboxOuterBorderWidth: 3,
            outerBorderColor: '#e3e6e8',
            outerBorderGap: 0
          }
        },
        { if: { checked: true }, tokens: { borderColor: '#7c53a5' } },
        {
          if: { checked: true, hover: true },
          tokens: { borderColor: '#4b286d' }
        },
        {
          if: { error: true },
          tokens: {
            borderColor: '#e12339',
            checkboxInputBorderColor: '#e12339',
            color: '#e12339'
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: 'rgba(0, 0, 0, 0)',
            checkboxCheckedBackgroundColor: '#676e73',
            checkboxInputBackgroundColor: '#b2b9bf',
            checkboxInputBorderColor: 'transparent',
            checkboxInputSize: 12,
            checkboxOuterBorderColor: '#b2b9bf',
            checkboxOuterBorderGap: 2,
            checkboxOuterBorderWidth: 1,
            color: '#676e73'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderRadius: 6,
        borderWidth: 1,
        checkboxCheckedBackgroundColor: '#7c53a5',
        checkboxCheckedSize: 12,
        checkboxInputBackgroundColor: '#ffffff',
        checkboxInputBorderColor: '#676e73',
        checkboxInputBorderWidth: 1,
        checkboxInputOutlineColor: 'rgba(0, 0, 0, 0)',
        checkboxInputOutlineWidth: 0,
        checkboxInputSize: 20,
        checkboxOuterBorderColor: 'transparent',
        checkboxOuterBorderGap: 0,
        checkboxOuterBorderWidth: 0,
        checkboxSpace: 2,
        color: '#2c2e30',
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 1,
        contentJustifyContent: 'flex-start',
        contentSpace: 2,
        flex: 1,
        fontName: 'HNforTELUSSA',
        fontSize: 20,
        fontWeight: '500',
        letterSpacing: 0,
        lineHeight: 1.4,
        minWidth: 264,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 2,
        paddingBottom: 16,
        paddingLeft: 10,
        paddingRight: 16,
        paddingTop: 16,
        shadow: null,
        textTransform: 'none'
      }
    },
    CheckboxCardGroup: {
      appearances: {
        fullWidth: {
          description: 'Makes cards always occupy the full width of the parent, regardless of viewport',
          type: 'variant',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { direction: 'row', space: 5 }
        },
        {
          if: { fullWidth: true },
          tokens: { direction: 'column', fieldSpace: 3, space: 3 }
        }
      ],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        direction: 'column',
        fieldSpace: 3,
        outlineOffset: 8,
        outlineWidth: 1,
        showIcon: true,
        space: 3
      }
    },
    CheckboxGroup: {
      appearances: {},
      rules: [],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        fieldSpace: 2,
        outlineOffset: 8,
        outlineWidth: 1,
        showIcon: true,
        space: 2
      }
    },
    ChevronLink: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        quiet: {
          description: 'When it is true, it does not show the decoration',
          type: 'state',
          values: [ true, false ]
        },
        size: {
          description: 'Sets the size of the text and icon; these variants are shared with ChevronLink',
          type: 'variant',
          values: [ 'large', 'small', 'micro' ]
        },
        style: {
          type: 'variant',
          values: [ 'inline', 'subtle', 'feature', 'danger', 'inverse' ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { color: '#1f5c09', iconDisplace: 4 }
        },
        { if: { pressed: true }, tokens: { color: '#163e06' } },
        { if: { alternative: true }, tokens: { color: '#414547' } },
        {
          if: { alternative: true, hover: true },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { alternative: true, pressed: true },
          tokens: { color: '#2c2e30' }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          if: { hover: true, inverse: true },
          tokens: { color: '#f4f4f7' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: { color: '#e3e6e8' }
        },
        {
          if: { size: 'large' },
          tokens: { blockLineHeight: 1.6, fontSize: 20, iconSize: 20 }
        },
        {
          if: { size: 'small' },
          tokens: {
            blockLineHeight: 1.42857142857,
            fontSize: 14,
            iconSize: 16
          }
        },
        {
          if: { size: 'micro' },
          tokens: {
            blockLineHeight: 1.33333333333,
            fontSize: 12,
            iconSize: 16
          }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#2b8000' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { outerBorderColor: '#163e06' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { outerBorderColor: '#ffffff' }
        },
        {
          if: { alternative: true, focus: true },
          tokens: { color: '#414547', outerBorderColor: '#414547' }
        },
        {
          if: { focus: true, quiet: true },
          tokens: { color: '#2b8000', textLine: 'underline' }
        },
        { if: { style: 'inline' }, tokens: { color: '#414547' } },
        {
          if: { focus: true, style: 'inline' },
          tokens: { color: '#414547', outerBorderColor: '#414547' }
        },
        {
          if: { hover: true, style: 'inline' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'inline' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'inline' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        { if: { style: 'subtle' }, tokens: { color: '#676e73' } },
        {
          if: { focus: true, style: 'subtle' },
          tokens: { color: '#676e73', outerBorderColor: '#676e73' }
        },
        {
          if: { hover: true, style: 'subtle' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'subtle' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'subtle' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        { if: { style: 'feature' }, tokens: { color: '#2b8000' } },
        {
          if: { focus: true, style: 'feature' },
          tokens: { color: '#2b8000', outerBorderColor: '#2b8000' }
        },
        {
          if: { hover: true, style: 'feature' },
          tokens: { color: '#1f5c09', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'feature' },
          tokens: { color: '#163e06', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'feature' },
          tokens: { outerBorderColor: '#163e06' }
        },
        { if: { style: 'danger' }, tokens: { color: '#c12335' } },
        {
          if: { focus: true, style: 'danger' },
          tokens: { color: '#c12335', outerBorderColor: '#c12335' }
        },
        {
          if: { hover: true, style: 'danger' },
          tokens: { color: '#560c0c', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'danger' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'danger' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        { if: { style: 'inverse' }, tokens: { color: '#ffffff' } },
        {
          if: { focus: true, style: 'inverse' },
          tokens: { color: '#ffffff', outerBorderColor: '#ffffff' }
        },
        {
          if: { hover: true, style: 'inverse' },
          tokens: { color: '#f4f4f7', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'inverse' },
          tokens: { color: '#b2b9bf', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'inverse' },
          tokens: { outerBorderColor: '#b2b9bf' }
        },
        {
          if: { quiet: true, style: 'inline' },
          tokens: { color: '#414547', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'inline' },
          tokens: {
            color: '#414547',
            outerBorderColor: '#414547',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'inline' },
          tokens: { color: '#2c2e30', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'inline' },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'inline' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        {
          if: { quiet: true, style: 'subtle' },
          tokens: { color: '#676e73', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'subtle' },
          tokens: {
            color: '#676e73',
            outerBorderColor: '#676e73',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'subtle' },
          tokens: { color: '#2c2e30', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'subtle' },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'subtle' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        {
          if: { quiet: true, style: 'feature' },
          tokens: { color: '#2b8000', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'feature' },
          tokens: {
            color: '#2b8000',
            outerBorderColor: '#2b8000',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'feature' },
          tokens: { color: '#1f5c09', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'feature' },
          tokens: { color: '#163e06' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'feature' },
          tokens: { outerBorderColor: '#163e06' }
        },
        {
          if: { quiet: true, style: 'danger' },
          tokens: { color: '#c12335', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'danger' },
          tokens: {
            color: '#c12335',
            outerBorderColor: '#c12335',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'danger' },
          tokens: { color: '#560c0c', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'danger' },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'danger' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        {
          if: { quiet: true, style: 'inverse' },
          tokens: { color: '#ffffff', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'inverse' },
          tokens: {
            color: '#ffffff',
            outerBorderColor: '#ffffff',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'inverse' },
          tokens: { color: '#f4f4f7', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'inverse' },
          tokens: { color: '#b2b9bf' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'inverse' },
          tokens: { outerBorderColor: '#b2b9bf' }
        }
      ],
      tokens: {
        blockLineHeight: 1.5,
        color: '#2b8000',
        fontSize: 16,
        iconDisplace: 0,
        iconSize: 16,
        iconSpace: 1,
        leftIcon: PaletteIconArrowLeft,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        rightIcon: PaletteIconArrowRight,
        textLine: 'none'
      }
    },
    ColourToggle: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            bubbleBorderColor: '#b2b9bf',
            bubbleBorderRadius: 45,
            bubbleBorderWidth: 1
          }
        },
        {
          if: { focus: true },
          tokens: {
            bubbleBorderColor: '#676e73',
            bubbleBorderRadius: 45,
            bubbleBorderWidth: 1
          }
        },
        {
          if: { pressed: true },
          tokens: {
            bubbleBorderColor: '#e3e6e8',
            bubbleBorderRadius: 45,
            bubbleBorderWidth: 1
          }
        },
        {
          if: { selected: true },
          tokens: {
            bubbleBorderColor: '#4b286d',
            bubbleBorderRadius: 45,
            bubbleBorderWidth: 1
          }
        }
      ],
      tokens: {
        borderColor: '#e3e6e8',
        borderRadius: 45,
        borderWidth: 1,
        bubbleBorderColor: 'rgba(0, 0, 0, 0)',
        bubbleBorderRadius: 0,
        bubbleBorderWidth: 0,
        innerBubbleBorderRadius: 45,
        innerBubbleHeight: 40,
        innerBubbleWidth: 40,
        outerBubbleContentAlignItems: 'center',
        outerBubbleHeight: 48,
        outerBubbleJustifyContent: 'center',
        outerBubbleWidth: 48,
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: true,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        },
        space: 2
      }
    },
    Countdown: {
      appearances: {
        feature: { type: 'variant', values: [ true ] },
        inverse: { type: 'variant', values: [ true ] },
        label: { type: 'variant', values: [ true ] },
        large: { type: 'variant', values: [ true ] },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            containerPaddingBottomTop: 16,
            containerPaddingLeftRight: 24,
            labelFontSize: 14,
            labelLineHeight: 1.42857142857,
            textLineHeight: 1.42857142857
          }
        },
        {
          if: { large: true },
          tokens: {
            textFontSize: 64,
            textLineHeight: 1.125,
            textTimerFontName: 'HNforTELUSSA',
            textTimerFontWeight: '300'
          }
        },
        {
          if: { feature: true },
          tokens: {
            labelBorderColor: '#4b286d',
            textFontSize: 64,
            textLineHeight: 1.125,
            textTimerFontName: 'HNforTELUSSA',
            textTimerFontWeight: '300'
          }
        },
        {
          if: { large: true, viewport: [ 'xs' ] },
          tokens: { textFontSize: 40 }
        },
        {
          if: { feature: true, viewport: [ 'xs' ] },
          tokens: { textFontSize: 40 }
        },
        {
          if: { inverse: true },
          tokens: { labelBorderColor: '#ffffff' }
        },
        {
          if: { feature: true, inverse: true },
          tokens: {
            containerBorderColor: '#676e73',
            labelBorderColor: '#ffffff'
          }
        }
      ],
      tokens: {
        containerBorderColor: 'rgba(0, 0, 0, 0)',
        containerBorderRadius: 6,
        containerBorderWidth: 2,
        containerGradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        },
        containerInverseBorder: 2,
        containerInverseBorderColor: '#ffffff',
        containerPaddingBottomTop: 48,
        containerPaddingLeftRight: 64,
        inverseBorderColor: '#676e73',
        labelBorderColor: '#414547',
        labelFontName: 'HNforTELUSSA',
        labelFontSize: 16,
        labelFontWeight: '400',
        labelLineHeight: 1.5,
        textFontSize: 16,
        textLineHeight: 1.5,
        textTimerFontName: 'HNforTELUSSA',
        textTimerFontWeight: '400'
      }
    },
    DatePicker: {
      appearances: {},
      rules: [],
      tokens: {
        calendarBackgroundColor: '#ffffff',
        calendarDayBlockedCalendarHoverBackground: '#f4f4f7',
        calendarDayBlockedCalendarHoverColor: '#b2b9bf',
        calendarDayDefaultBackgroundColor: '#ffffff',
        calendarDayDefaultBorder: 1,
        calendarDayDefaultBorderColor: '#b2b9bf',
        calendarDayDefaultCalendarDaySelectedHoverBackground: '#ffffff',
        calendarDayDefaultCalendarDaySelectedHoverBeforeBackground: '#7c53a5',
        calendarDayDefaultCalendarDaySelectedHoverColor: '#ffffff',
        calendarDayDefaultColor: '#414547',
        calendarDayDefaultFontName: 'HNforTELUSSA',
        calendarDayDefaultFontSize: 14,
        calendarDayDefaultFontWeight: '400',
        calendarDaySelectedDisabledBackground: '#fafafa',
        calendarDaySelectedDisabledColor: '#ffffff',
        calendarDaySelectedDisabledContentBackgroundColor: '#b2b9bf',
        calendarDaySelectedFocusBeforeBackground: '#ffffff',
        calendarDaySelectedHoverBackground: '#ffffff',
        calendarDaySelectedHoverBeforeBackground: '#ffffff',
        calendarDaySelectedHoverBeforeBorderColor: '#7c53a5',
        calendarDaySelectedHoverBorderColor: '#b2b9bf',
        calendarDaySelectedHoverColor: '#414547',
        calendarMonthCaptionColor: '#2c2e30',
        calendarMonthCaptionFontName: 'HNforTELUSSA',
        calendarMonthCaptionFontSize: 20,
        calendarMonthCaptionFontWeight: '700',
        calendarMonthCaptionLineHeight: 1.4,
        calendarMonthCaptionPaddingBottom: 48,
        dateInputStrokeColor: '#676e73',
        dayPickerNavigationButtonPadding: 8,
        dayPickerWeekHeaderColor: '#414547',
        dayPickerWeekHeaderFontName: 'HNforTELUSSA',
        dayPickerWeekHeaderFontWeight: '700',
        dayPickerWeekHeaderLineHeight: 1.42857142857,
        dayPickerWeekHeaderSmall: 14,
        hiddenInputFieldContainerHeight: 0,
        hiddenInputFieldContainerWidth: 0,
        invalidInputMixin: '#e12339',
        nextIcon: PaletteIconArrowRight,
        previousIcon: PaletteIconArrowLeft,
        singleDatePickerBorderColor: '#676e73',
        singleDatePickerLeftRight: 16,
        singleDatePickerPaddingTopBottom: 8,
        singleDatePickerRadius: 4,
        validInputMixin: '#2b8000'
      }
    },
    Disclaimer: {
      appearances: {},
      rules: [],
      tokens: {
        color: '#414547',
        fontName: 'HNforTELUSSA',
        fontSize: 12,
        fontWeight: '500',
        lineHeight: 1.33333333333
      }
    },
    Divider: {
      appearances: {
        decorative: {
          description: 'Use a decorative divider to highlight an element. Non-decorative dividers are for clearly identifying separation of content.',
          type: 'variant',
          values: [ true ]
        },
        inverse: { type: 'variant', values: [ true ] },
        weight: { type: 'variant', values: [ 'thick' ] }
      },
      rules: [
        { if: { weight: 'thick' }, tokens: { width: 2 } },
        { if: { decorative: true }, tokens: { color: '#b2b9bf' } },
        { if: { inverse: true }, tokens: { color: '#ffffff' } }
      ],
      tokens: { color: '#676e73', width: 1 }
    },
    DownloadApp: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { focus: true },
          tokens: { borderColor: '#2b8000', borderRadius: 4 }
        },
        {
          if: { hover: true },
          tokens: { borderColor: '#b2b9bf', borderRadius: 4 }
        },
        {
          if: { pressed: true },
          tokens: { borderColor: '#1f5c09', borderRadius: 4 }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { borderColor: '#1f5c09', borderRadius: 4 }
        }
      ],
      tokens: {
        androidENIcon: PaletteIconAndroidEN,
        androidFRIcon: PaletteIconAndroidFR,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderGap: 2,
        borderRadius: 0,
        borderWidth: 1,
        iosENIcon: PaletteIconIOSEN,
        iosFRIcon: PaletteIconIOSFR,
        padding: 1
      }
    },
    ExpandCollapse: {
      appearances: {},
      rules: [],
      tokens: { borderColor: '#b2b9bf', borderStyle: 'solid', borderWidth: 0 }
    },
    ExpandCollapseControl: {
      appearances: {
        compact: { type: 'variant', values: [ true ] },
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        mini: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { expanded: true },
          tokens: { icon: PaletteIconCaretUp }
        },
        {
          if: { compact: true },
          tokens: {
            paddingBottom: 8,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 8
          }
        },
        {
          if: { mini: true },
          tokens: { borderWidth: null, paddingBottom: 0, paddingTop: 0 }
        },
        {
          if: { focus: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#676e73',
            borderWidth: 1
          }
        },
        {
          if: { focus: true, mini: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#676e73',
            borderWidth: null
          }
        },
        {
          if: { hover: true },
          tokens: { backgroundColor: '#fafafa', iconPaddingTop: 8 }
        },
        {
          if: { expanded: true, hover: true },
          tokens: { backgroundColor: '#fafafa', iconPaddingTop: 0 }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#e3e6e8',
            borderColor: '#676e73',
            borderWidth: 1
          }
        },
        {
          if: { mini: true, pressed: true },
          tokens: {
            backgroundColor: '#e3e6e8',
            borderColor: '#676e73',
            borderWidth: null
          }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderWidth: 1,
        icon: PaletteIconCaretDown,
        iconColor: '#2b8000',
        iconGap: 8,
        iconPaddingTop: 4,
        iconPosition: 'left',
        iconSize: 16,
        justifyContent: 'flex-start',
        paddingBottom: 16,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 16,
        textLine: 'none',
        verticalAlign: 'top'
      }
    },
    ExpandCollapseMini: { appearances: {}, rules: [], tokens: { borderWidth: 0 } },
    ExpandCollapseMiniControl: {
      appearances: {
        alternative: {
          description: 'Replaces the default green colour with a more subtle grey.',
          type: 'variant',
          values: [ true ]
        },
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        inverse: {
          description: 'Replaces the default green colour with white. Useful for dark backgrounds.',
          type: 'variant',
          values: [ true ]
        },
        quiet: {
          description: 'When it is true, it does not show the decoration',
          type: 'state',
          values: [ true, false ]
        },
        size: { type: 'variant', values: [ 'micro', 'small', 'large' ] }
      },
      rules: [
        {
          if: { expanded: true },
          tokens: { icon: PaletteIconCaretUp }
        },
        { if: { alternative: true }, tokens: { color: '#414547' } },
        {
          if: { inverse: true },
          tokens: { color: '#ffffff', iconColor: '#ffffff' }
        },
        {
          if: { size: 'micro' },
          tokens: { fontSize: 12, iconSize: 16, lineHeight: 1.33333333333 }
        },
        {
          if: { size: 'small' },
          tokens: { fontSize: 14, iconSize: 16, lineHeight: 1.42857142857 }
        },
        {
          if: { size: 'large' },
          tokens: { fontSize: 20, iconSize: 20, lineHeight: 1.6 }
        },
        { if: { quiet: true }, tokens: { textLine: 'none' } },
        {
          if: { alternative: true, quiet: true },
          tokens: { color: '#414547', textLine: 'none' }
        },
        {
          if: { inverse: true, quiet: true },
          tokens: { color: '#ffffff', iconColor: '#ffffff', textLine: 'none' }
        }
      ],
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        color: '#2b8000',
        fontSize: 16,
        icon: PaletteIconCaretDown,
        iconColor: '#2b8000',
        iconGap: 8,
        iconPaddingTop: 4,
        iconPosition: 'left',
        iconSize: 16,
        justifyContent: 'flex-start',
        lineHeight: 1.5,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        size: 4,
        textLine: 'underline',
        verticalAlign: 'top'
      }
    },
    ExpandCollapsePanel: {
      appearances: {
        compact: { type: 'variant', values: [ true ] },
        mini: { type: 'variant', values: [ true ] }
      },
      rules: [
        {
          if: { compact: true },
          tokens: {
            contentPaddingBottom: 16,
            contentPaddingLeft: 24,
            contentPaddingRight: 0,
            contentPaddingTop: 8
          }
        },
        {
          if: { mini: true },
          tokens: {
            contentPaddingBottom: 0,
            contentPaddingLeft: 0,
            contentPanelPaddingBottom: 0,
            contentPanelPaddingTop: 0
          }
        }
      ],
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 0,
        borderWidth: 0,
        collapseDuration: 250,
        contentPaddingBottom: 16,
        contentPaddingLeft: 24,
        contentPaddingRight: 0,
        contentPaddingTop: 0,
        contentPanelBackgroundColor: 'rgba(0, 0, 0, 0)',
        contentPanelBorderColor: 'rgba(0, 0, 0, 0)',
        contentPanelBorderWidth: 0,
        contentPanelFontColor: '#2c2e30',
        contentPanelFontName: 'HNforTELUSSA',
        contentPanelFontSize: 16,
        contentPanelFontWeight: '700',
        contentPanelLineHeight: 1.5,
        contentPanelPaddingBottom: 16,
        contentPanelPaddingLeft: 24,
        contentPanelPaddingRight: 0,
        contentPanelPaddingTop: 16,
        expandDividerColor: 'rgba(0, 0, 0, 0)',
        expandDividerWidth: 0,
        expandDuration: 300,
        marginBottom: 0
      }
    },
    Feedback: {
      appearances: {
        icon: { type: 'variant', values: [ true ] },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        }
      },
      rules: [
        {
          if: { validation: 'success' },
          tokens: {
            backgroundColor: '#f4f9f2',
            borderColor: '#f4f9f2',
            color: '#163e06'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            backgroundColor: '#fff6f8',
            borderColor: '#fff6f8',
            color: '#c12335'
          }
        },
        {
          if: { icon: true, validation: 'success' },
          tokens: { icon: PaletteIconStatusSuccess, iconColor: '#2b8000' }
        },
        {
          if: { icon: true, validation: 'error' },
          tokens: { icon: PaletteIconStatusError, iconColor: '#c12335' }
        }
      ],
      tokens: {
        backgroundColor: '#efedff',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 4,
        borderWidth: 1,
        color: '#2c2e30',
        contentFontSize: 16,
        fontName: 'HNforTELUSSA',
        fontWeight: '400',
        icon: null,
        iconColor: 'rgba(0, 0, 0, 0)',
        iconGap: 8,
        iconSize: 24,
        lineHeight: 1.5,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        space: 2,
        titleFontSize: 16
      }
    },
    Fieldset: {
      appearances: { error: { type: 'variant', values: [ true ] } },
      rules: [ { if: { error: true }, tokens: { outlineColor: '#e12339' } } ],
      tokens: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        outlineColor: 'rgba(0, 0, 0, 0)',
        outlineOffset: null,
        outlineWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0
      }
    },
    FileUpload: {
      appearances: {},
      rules: [],
      tokens: {
        buttonBackgroundColor: null,
        buttonBorderColor: null,
        buttonBorderRadius: null,
        buttonBorderWidth: null,
        buttonHeight: null,
        buttonMinWidth: null,
        buttonTextColor: null,
        buttonWidth: null,
        notificationBackgroundColor: null,
        notificationBorderColor: null,
        notificationBorderRadius: null,
        notificationDismissButtonGap: null,
        notificationDismissIcon: null,
        notificationDismissIconColor: null,
        notificationIcon: null,
        notificationIconColor: null,
        notificationIconGap: null,
        notificationIconSize: null,
        notificationTextColor: '#414547'
      }
    },
    Footnote: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            footnoteBodyPaddingBottom: 32,
            footnoteBodyPaddingLeft: 16,
            footnoteBodyPaddingRight: 16,
            footnoteBodyPaddingTop: 0,
            footnoteHeaderPaddingBottom: 16,
            footnoteHeaderPaddingLeft: 16,
            footnoteHeaderPaddingRight: 4,
            footnoteHeaderPaddingTop: 16
          }
        },
        {
          if: { viewport: [ 'md', 'lg' ] },
          tokens: {
            footnoteBodyPaddingBottom: 40,
            footnoteBodyPaddingLeft: 16,
            footnoteBodyPaddingRight: 16,
            footnoteBodyPaddingTop: 0,
            footnoteHeaderPaddingBottom: 24,
            footnoteHeaderPaddingLeft: 16,
            footnoteHeaderPaddingRight: 4,
            footnoteHeaderPaddingTop: 24
          }
        },
        {
          if: { viewport: [ 'xl' ] },
          tokens: {
            footnoteBodyPaddingBottom: 40,
            footnoteBodyPaddingLeft: 16,
            footnoteBodyPaddingRight: 16,
            footnoteBodyPaddingTop: 0,
            footnoteHeaderPaddingBottom: 24,
            footnoteHeaderPaddingLeft: 16,
            footnoteHeaderPaddingRight: 16,
            footnoteHeaderPaddingTop: 24
          }
        }
      ],
      tokens: {
        closeButtonBackgroundColor: '#f4f4f7',
        closeButtonBorderColor: '#676e73',
        closeButtonBorderSize: 1,
        closeButtonHeight: 24,
        closeButtonIconSize: 16,
        closeButtonMarginBottom: 12,
        closeButtonMarginLeft: 4,
        closeButtonMarginRight: 4,
        closeButtonMarginTop: 12,
        closeButtonWidth: 24,
        closeIcon: PaletteIconClose,
        footnoteBackground: '#f4f4f7',
        footnoteBodyBackground: '#f4f4f7',
        footnoteBodyPaddingBottom: 40,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteBorderColorMd: '#b2b9bf',
        footnoteBorderTopSizeMd: 1,
        footnoteHeaderPaddingBottom: 24,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 4,
        footnoteHeaderPaddingTop: 24,
        headerFontName: 'HNforTELUSSA',
        headerFontSize: 16,
        headerFontWeight: '500',
        headerLineHeight: 1.5,
        headerMargin: 16,
        listItemColor: '#414547',
        listItemFontName: 'HNforTELUSSA',
        listItemFontSize: 16,
        listItemFontWeight: '400',
        listItemLineHeight: 1.5,
        listItemMarkerFontSize: 16,
        listItemMarkerLineHeight: 1.5,
        listItemPaddingLeft: 8,
        listPaddingLeft: 32
      }
    },
    FootnoteLink: {
      appearances: {
        size: {
          type: 'variant',
          values: [
            'micro',    'small',
            'medium',   'large',
            'h1',       'h2',
            'h3',       'h4',
            'h5',       'h6',
            'display1', 'display2'
          ]
        }
      },
      rules: [
        {
          if: { size: 'display1' },
          tokens: { fontSize: 20, lineHeight: 1.2 }
        },
        {
          if: { size: 'display2' },
          tokens: { fontSize: 20, lineHeight: 1.2 }
        },
        {
          if: { size: 'h1' },
          tokens: { fontSize: 20, lineHeight: 1.2 }
        },
        {
          if: { size: 'h2' },
          tokens: { fontSize: 20, lineHeight: 1.2 }
        },
        { if: { size: 'h3' }, tokens: { fontSize: 14, lineHeight: 1 } },
        { if: { size: 'h4' }, tokens: { fontSize: 14, lineHeight: 1 } },
        { if: { size: 'h5' }, tokens: { fontSize: 14, lineHeight: 1 } },
        { if: { size: 'h6' }, tokens: { fontSize: 14, lineHeight: 1 } },
        {
          if: { size: 'micro' },
          tokens: { fontSize: 12, lineHeight: 1 }
        },
        {
          if: { size: 'small' },
          tokens: { fontSize: 12, lineHeight: 1 }
        },
        {
          if: { size: 'medium' },
          tokens: { fontSize: 12, lineHeight: 1 }
        },
        {
          if: { size: 'large' },
          tokens: { fontSize: 12, lineHeight: 1 }
        }
      ],
      tokens: {
        color: null,
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        lineHeight: 1,
        paddingLeft: 2,
        paddingRight: 2
      }
    },
    HorizontalScrollButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { borderColor: '#414547', iconColor: '#414547' }
        },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#676e73', iconColor: '#ffffff' }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderRadius: 32,
        borderWidth: 1,
        iconColor: '#676e73',
        iconScale: 1,
        iconSize: 16,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        padding: 8,
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.2)',
          inset: false,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        }
      }
    },
    Icon: {
      appearances: {
        background: { type: 'variant', values: [ true ] },
        color: {
          type: 'variant',
          values: [
            'brand',   'subtle',
            'offer',   'success',
            'danger',  'warning',
            'inverse', 'default'
          ]
        },
        padding: {
          type: 'variant',
          values: [ 'micro', 'small', 'medium', 'large', 'extraLarge' ]
        },
        rank: { type: 'variant', values: [ 'primary' ] },
        size: {
          type: 'variant',
          values: [ 'micro', 'small', 'large', 'extraLarge' ]
        },
        style: {
          type: 'variant',
          values: [ 'default', 'brand', 'dark', 'light' ]
        }
      },
      rules: [
        { if: { padding: 'micro' }, tokens: { padding: 4, width: 4 } },
        { if: { padding: 'small' }, tokens: { padding: 4, width: 8 } },
        {
          if: { padding: 'medium' },
          tokens: { padding: 4, width: 16 }
        },
        { if: { padding: 'large' }, tokens: { padding: 4, width: 24 } },
        {
          if: { padding: 'extraLarge' },
          tokens: { padding: 4, width: 32 }
        },
        {
          if: { background: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderRadius: 45,
            padding: 4,
            width: 8
          }
        },
        {
          if: { background: true, padding: 'micro' },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderRadius: 45,
            padding: 4,
            width: 4
          }
        },
        {
          if: { background: true, padding: 'small' },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderRadius: 45,
            padding: 4,
            width: 8
          }
        },
        {
          if: { background: true, padding: 'medium' },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderRadius: 45,
            padding: 4,
            width: 16
          }
        },
        {
          if: { background: true, padding: 'large' },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderRadius: 45,
            padding: 4,
            width: 24
          }
        },
        {
          if: { background: true, padding: 'extraLarge' },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderRadius: 45,
            padding: 4,
            width: 32
          }
        },
        {
          if: { style: 'default' },
          tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
        },
        {
          if: { style: 'brand' },
          tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
        },
        {
          if: { style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { style: 'light' },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'micro', style: 'default' },
          tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'small', style: 'default' },
          tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'medium', style: 'default' },
          tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'large', style: 'default' },
          tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'extraLarge', style: 'default' },
          tokens: { backgroundColor: '#f4f4f7', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'micro', style: 'brand' },
          tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'small', style: 'brand' },
          tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'medium', style: 'brand' },
          tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'large', style: 'brand' },
          tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'extraLarge', style: 'brand' },
          tokens: { backgroundColor: '#4b286d', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'micro', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'small', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'medium', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'large', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'extraLarge', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'micro', style: 'light' },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'small', style: 'light' },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'medium', style: 'light' },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'large', style: 'light' },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'extraLarge', style: 'light' },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: 45,
            padding: 4
          }
        },
        { if: { size: 'micro' }, tokens: { size: 16 } },
        { if: { size: 'small' }, tokens: { size: 20 } },
        { if: { size: 'large' }, tokens: { size: 32 } },
        { if: { size: 'extraLarge' }, tokens: { size: 48 } },
        { if: { color: 'brand' }, tokens: { color: '#4b286d' } },
        { if: { color: 'default' }, tokens: { color: '#414547' } },
        { if: { color: 'subtle' }, tokens: { color: '#676e73' } },
        { if: { color: 'success' }, tokens: { color: '#2b8000' } },
        { if: { color: 'danger' }, tokens: { color: '#c12335' } },
        { if: { color: 'warning' }, tokens: { color: '#c77539' } },
        { if: { color: 'inverse' }, tokens: { color: '#ffffff' } },
        {
          if: { color: 'offer' },
          tokens: {
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        { if: { rank: 'primary' }, tokens: { color: '#4b286d' } }
      ],
      tokens: {
        backgroundColor: 'transparent',
        borderRadius: 0,
        color: '#414547',
        gradient: null,
        padding: 0,
        paddingTop: 0,
        scale: 1,
        size: 24,
        translateX: 0,
        translateY: 0,
        width: 0
      }
    },
    IconButton: {
      appearances: {
        action: {
          type: 'variant',
          values: [
            'add',      'close',
            'expand',   'moveDown',
            'moveLeft', 'moveRight',
            'moveUp',   'play',
            'subtract'
          ]
        },
        compact: {
          description: 'Without the outer border gap',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        inverse: {
          description: 'For use on dark backgrounds',
          type: 'variant',
          values: [ true ]
        },
        password: {
          description: 'Password masked or not',
          type: 'variant',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        raised: {
          description: 'Uses shadow and background colour to appear raised above the page',
          type: 'variant',
          values: [ true ]
        },
        size: { type: 'variant', values: [ 'small', 'large' ] }
      },
      rules: [
        { if: { action: 'add' }, tokens: { icon: PaletteIconAdd } },
        {
          if: { action: 'subtract' },
          tokens: { icon: PaletteIconSubtract }
        },
        {
          if: { action: 'close' },
          tokens: { icon: PaletteIconClose }
        },
        {
          if: { action: 'expand' },
          tokens: { icon: PaletteIconExpand }
        },
        {
          if: { action: 'moveDown' },
          tokens: { icon: PaletteIconCaretDown }
        },
        {
          if: { action: 'moveUp' },
          tokens: { icon: PaletteIconCaretUp }
        },
        {
          if: { action: 'moveLeft' },
          tokens: { icon: PaletteIconChevronLeft }
        },
        {
          if: { action: 'moveRight' },
          tokens: { icon: PaletteIconChevronRight }
        },
        {
          if: { action: 'play' },
          tokens: { icon: PaletteIconPlayVideo }
        },
        { if: { action: 'add' }, tokens: { icon: PaletteIconAdd } },
        {
          if: { action: 'subtract' },
          tokens: { icon: PaletteIconSubtract }
        },
        {
          if: { action: 'close' },
          tokens: { icon: PaletteIconClose }
        },
        {
          if: { action: 'expand' },
          tokens: { icon: PaletteIconExpand }
        },
        {
          if: { action: 'moveDown' },
          tokens: { icon: PaletteIconCaretDown }
        },
        {
          if: { action: 'moveUp' },
          tokens: { icon: PaletteIconCaretUp }
        },
        {
          if: { action: 'moveLeft' },
          tokens: { icon: PaletteIconChevronLeft }
        },
        {
          if: { action: 'moveRight' },
          tokens: { icon: PaletteIconChevronRight }
        },
        {
          if: { action: 'play' },
          tokens: { icon: PaletteIconPlayVideo }
        },
        {
          if: { inverse: true },
          tokens: { borderColor: '#ffffff', iconColor: '#ffffff' }
        },
        {
          if: { hover: true },
          tokens: {
            borderColor: '#414547',
            iconColor: '#414547',
            iconScale: 1.1
          }
        },
        { if: { hover: true }, tokens: { iconScale: 1 } },
        {
          if: { hover: true, password: true },
          tokens: {
            backgroundColor: '#7c53a5',
            borderColor: '#7c53a5',
            iconColor: '#ffffff'
          }
        },
        {
          if: { password: true },
          tokens: { borderColor: 'transparent' }
        },
        {
          if: { focus: true, password: true },
          tokens: { borderColor: '#4b286d' }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { borderColor: '#ffffff', iconColor: '#ffffff' }
        },
        {
          if: { focus: true },
          tokens: {
            outerBorderColor: '#676e73',
            outerBorderGap: 4,
            outerBorderWidth: 1
          }
        },
        {
          if: { focus: true, password: true },
          tokens: {
            borderWidth: 3,
            outerBorderColor: '#3f2a54',
            outerBorderWidth: 0
          }
        },
        {
          if: { focus: true, inverse: true },
          tokens: {
            backgroundColor: 'transparent',
            borderColor: '#ffffff',
            iconColor: '#ffffff',
            outerBorderColor: '#ffffff',
            outerBorderWidth: 1
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#676e73',
            borderColor: '#ffffff',
            iconColor: '#ffffff',
            outerBorderGap: 4
          }
        },
        {
          if: { password: true, pressed: true },
          tokens: {
            backgroundColor: '#3f2a54',
            borderColor: '#3f2a54',
            iconColor: '#ffffff',
            outerBorderGap: 0
          }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            borderColor: '#ffffff',
            iconColor: '#ffffff',
            outerBorderWidth: 0
          }
        },
        {
          if: { size: 'large' },
          tokens: { iconSize: 24, padding: 12 }
        },
        { if: { size: 'small' }, tokens: { iconSize: 16, padding: 4 } },
        {
          description: 'Raised IconButtons follow different design patterns to other variants',
          if: { raised: true },
          tokens: {
            backgroundColor: '#ffffff',
            borderColor: '#b2b9bf',
            borderWidth: 1,
            iconSize: 16,
            outerBorderColor: 'transparent',
            outerBorderGap: 0,
            outerBorderWidth: 0,
            padding: 8,
            shadow: {
              blur: 2,
              color: 'rgba(0, 0, 0, 0.2)',
              inset: false,
              offsetX: 0,
              offsetY: 2,
              spread: 0
            }
          }
        },
        {
          if: { raised: true, size: 'large' },
          tokens: { iconSize: 24, padding: 12 }
        },
        { if: { raised: true, size: 'small' }, tokens: { padding: 8 } },
        {
          if: { pressed: true, raised: true },
          tokens: { backgroundColor: '#676e73', borderWidth: 0 }
        },
        {
          if: { inactive: true, password: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0,
            iconColor: '#e3e6e8',
            outerBorderColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { hover: true, raised: true },
          tokens: { borderColor: '#b2b9bf', borderWidth: 3 }
        },
        {
          if: { focus: true, raised: true },
          tokens: {
            borderColor: '#4b286d',
            borderWidth: 3,
            iconColor: '#4b286d'
          }
        },
        {
          if: { focus: true, pressed: true, raised: true },
          tokens: {
            backgroundColor: '#4b286d',
            borderWidth: 0,
            iconColor: '#ffffff'
          }
        },
        { if: { compact: true }, tokens: { outerBorderGap: 0 } }
      ],
      tokens: {
        backgroundColor: 'transparent',
        borderBottomLeftRadius: null,
        borderBottomRightRadius: null,
        borderBottomWidth: null,
        borderColor: '#676e73',
        borderLeftWidth: null,
        borderRadius: 99999999999999,
        borderRightWidth: null,
        borderTopLeftRadius: null,
        borderTopRightRadius: null,
        borderTopWidth: null,
        borderWidth: 1,
        height: null,
        icon: PaletteIconAdd,
        iconColor: '#676e73',
        iconScale: 1,
        iconSize: 16,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: null,
        padding: 4,
        shadow: null,
        width: null
      }
    },
    Image: { appearances: {}, rules: [], tokens: { borderRadius: null } },
    InputLabel: {
      appearances: {},
      rules: [],
      tokens: {
        color: '#414547',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '700',
        gap: 8,
        hintColor: '#414547',
        hintFontName: 'HNforTELUSSA',
        hintFontSize: 14,
        hintFontWeight: '400',
        hintLineHeight: 1.42857142857,
        lineHeight: 1.5
      }
    },
    InputSupports: { appearances: {}, rules: [], tokens: { space: 1 } },
    Link: {
      appearances: {
        alternative: {
          description: 'Replaces the default green colour with a more subtle grey.',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        iconPosition: {
          description: 'Theme styles to be applied to icon links depending on where the icon is in relation to the link text',
          type: 'state',
          values: [ 'left', 'right', 'inline' ]
        },
        inverse: {
          description: 'Styles the link white for use on dark backgrounds.',
          type: 'variant',
          values: [ true ]
        },
        light: {
          description: 'A lighter grey variant, used to lower the emphasis on a given Link (e.g. in Breadcrumbs)',
          type: 'variant',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        quiet: {
          description: 'When it is true, it does not show the decoration',
          type: 'state',
          values: [ true, false ]
        },
        size: {
          description: 'Text sizes for block links; similar but not always identical to Typography sizes.',
          type: 'variant',
          values: [ 'large', 'small', 'micro' ]
        },
        style: {
          type: 'variant',
          values: [ 'inline', 'subtle', 'feature', 'danger', 'inverse' ]
        }
      },
      rules: [
        { if: { iconPosition: 'left' }, tokens: { iconSpace: 2 } },
        { if: { iconPosition: 'right' }, tokens: { iconSpace: 1 } },
        { if: { iconPosition: 'inline' }, tokens: { iconSpace: 2 } },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#2b8000', outerBorderOutline: 'none' }
        },
        {
          if: { hover: true },
          tokens: { color: '#1f5c09', textLine: 'none' }
        },
        {
          if: { pressed: true },
          tokens: { color: '#163e06', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { outerBorderColor: '#163e06' }
        },
        {
          if: { size: 'large' },
          tokens: { blockFontSize: 20, blockLineHeight: 1.25, iconSize: 24 }
        },
        {
          if: { size: 'small' },
          tokens: { blockFontSize: 14, blockLineHeight: 1, iconSize: 20 }
        },
        {
          if: { size: 'micro' },
          tokens: {
            blockFontName: 'HNforTELUSSA',
            blockFontSize: 12,
            blockFontWeight: '500',
            blockLineHeight: 1.125,
            iconSize: 16
          }
        },
        { if: { alternative: true }, tokens: { color: '#2c2e30' } },
        {
          if: { alternative: true, focus: true },
          tokens: { color: '#414547', outerBorderColor: '#414547' }
        },
        {
          if: { alternative: true, hover: true },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { alternative: true, pressed: true },
          tokens: { color: '#2c2e30' }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          if: { hover: true, inverse: true },
          tokens: { color: '#f4f4f7' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { outerBorderColor: '#ffffff', outerBorderOutline: 'none' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: { color: '#e3e6e8' }
        },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: { color: '#e3e6e8', outerBorderColor: '#e3e6e8' }
        },
        { if: { light: true }, tokens: { color: '#676e73' } },
        {
          if: { focus: true, light: true },
          tokens: { color: '#676e73', outerBorderColor: '#676e73' }
        },
        {
          if: { hover: true, light: true },
          tokens: { color: '#414547', textLine: 'none' }
        },
        { if: { quiet: true }, tokens: { textLine: 'none' } },
        {
          if: { hover: true, quiet: true },
          tokens: { color: '#1f5c09', textLine: 'underline' }
        },
        {
          if: { focus: true, quiet: true },
          tokens: { color: '#2b8000', textLine: 'underline' }
        },
        {
          if: { alternative: true, hover: true, quiet: true },
          tokens: { color: '#2c2e30', textLine: 'underline' }
        },
        {
          if: { hover: true, inverse: true, quiet: true },
          tokens: { color: '#f4f4f7', textLine: 'underline' }
        },
        {
          if: { hover: true, light: true, quiet: true },
          tokens: { color: '#414547', textLine: 'underline' }
        },
        { if: { style: 'inline' }, tokens: { color: '#414547' } },
        {
          if: { focus: true, style: 'inline' },
          tokens: {
            color: '#414547',
            outerBorderColor: '#414547',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'inline' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'inline' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'inline' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        { if: { style: 'subtle' }, tokens: { color: '#676e73' } },
        {
          if: { focus: true, style: 'subtle' },
          tokens: {
            color: '#676e73',
            outerBorderColor: '#676e73',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'subtle' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'subtle' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'subtle' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        { if: { style: 'feature' }, tokens: { color: '#2b8000' } },
        {
          if: { focus: true, style: 'feature' },
          tokens: {
            color: '#2b8000',
            outerBorderColor: '#2b8000',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'feature' },
          tokens: { color: '#1f5c09', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'feature' },
          tokens: { color: '#163e06', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'feature' },
          tokens: { outerBorderColor: '#163e06' }
        },
        { if: { style: 'danger' }, tokens: { color: '#c12335' } },
        {
          if: { focus: true, style: 'danger' },
          tokens: {
            color: '#c12335',
            outerBorderColor: '#c12335',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'danger' },
          tokens: { color: '#560c0c', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'danger' },
          tokens: { color: '#2c2e30', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'danger' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        { if: { style: 'inverse' }, tokens: { color: '#ffffff' } },
        {
          if: { focus: true, style: 'inverse' },
          tokens: {
            color: '#ffffff',
            outerBorderColor: '#ffffff',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'inverse' },
          tokens: { color: '#f4f4f7', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'inverse' },
          tokens: { color: '#b2b9bf', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'inverse' },
          tokens: { outerBorderColor: '#b2b9bf' }
        },
        {
          if: { quiet: true, style: 'inline' },
          tokens: { color: '#414547', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'inline' },
          tokens: {
            color: '#414547',
            outerBorderColor: '#414547',
            outerBorderOutline: 'none',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'inline' },
          tokens: { color: '#2c2e30', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'inline' },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'inline' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        {
          if: { quiet: true, style: 'subtle' },
          tokens: { color: '#676e73', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'subtle' },
          tokens: {
            color: '#676e73',
            outerBorderColor: '#676e73',
            outerBorderOutline: 'none',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'subtle' },
          tokens: { color: '#2c2e30', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'subtle' },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'subtle' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        {
          if: { quiet: true, style: 'feature' },
          tokens: { color: '#2b8000', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'feature' },
          tokens: {
            color: '#2b8000',
            outerBorderColor: '#2b8000',
            outerBorderOutline: 'none',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'feature' },
          tokens: { color: '#1f5c09', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'feature' },
          tokens: { color: '#163e06' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'feature' },
          tokens: { outerBorderColor: '#163e06' }
        },
        {
          if: { quiet: true, style: 'danger' },
          tokens: { color: '#c12335', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'danger' },
          tokens: {
            color: '#c12335',
            outerBorderColor: '#c12335',
            outerBorderOutline: 'none',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'danger' },
          tokens: { color: '#560c0c', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'danger' },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'danger' },
          tokens: { outerBorderColor: '#2c2e30' }
        },
        {
          if: { quiet: true, style: 'inverse' },
          tokens: { color: '#ffffff', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'inverse' },
          tokens: {
            color: '#ffffff',
            outerBorderColor: '#ffffff',
            outerBorderOutline: 'none',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'inverse' },
          tokens: { color: '#f4f4f7', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'inverse' },
          tokens: { color: '#b2b9bf' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'inverse' },
          tokens: { outerBorderColor: '#b2b9bf' }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        blockFontName: 'HNforTELUSSA',
        blockFontSize: 16,
        blockFontWeight: '400',
        blockLineHeight: 1.5,
        borderRadius: 4,
        color: '#2b8000',
        icon: null,
        iconSize: 24,
        iconSpace: 1,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderOutline: 'none',
        outerBorderWidth: 2,
        textLine: 'underline',
        textLineStyle: 'solid'
      }
    },
    List: {
      appearances: {
        compact: {
          description: 'When true it will reduce the line height of the list item.',
          type: 'variant',
          values: [ true ]
        },
        size: {
          description: 'Indicates list item text size.',
          type: 'variant',
          values: [ 'large', 'small' ]
        }
      },
      rules: [
        {
          if: { size: 'large' },
          tokens: {
            iconMarginTop: 4,
            itemFontSize: 20,
            itemIconSize: 24,
            itemLineHeight: 1.6
          }
        },
        {
          if: { size: 'small' },
          tokens: {
            iconMarginTop: 0,
            itemBulletContainerHeight: 20,
            itemFontSize: 14,
            itemIconSize: 20,
            itemLineHeight: 1.42857142857
          }
        },
        {
          if: { compact: true },
          tokens: { iconMarginTop: 0, itemLineHeight: 1.25 }
        },
        {
          if: { compact: true, size: 'small' },
          tokens: { itemLineHeight: 1.14285714286 }
        },
        {
          if: { compact: true, size: 'large' },
          tokens: { itemLineHeight: 1.2 }
        }
      ],
      tokens: {
        bulletIcon: PaletteIconBulletFill,
        dividerColor: '#b2b9bf',
        dividerSize: 1,
        iconMarginTop: 0,
        interItemMargin: 8,
        interItemMarginWithDivider: 16,
        itemBulletColor: '#4b286d',
        itemBulletContainerAlign: 'center',
        itemBulletContainerHeight: 24,
        itemBulletContainerWidth: 24,
        itemFontName: 'HNforTELUSSA',
        itemFontSize: 16,
        itemFontWeight: '400',
        itemIconColor: '#4b286d',
        itemIconSize: 24,
        itemLineHeight: 1.5,
        itemTextColor: '#414547',
        listGutter: 8
      }
    },
    Listbox: {
      appearances: {
        current: {
          description: 'When the current item is selected',
          type: 'state',
          values: [ true, false ]
        },
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        isChild: {
          description: 'when the item is child of another child',
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { focus: true, hover: true, pressed: true },
          tokens: {
            groupBackgroundColor: '#e3e6e8',
            groupBorderColor: 'rgba(0, 0, 0, 0)',
            groupColor: '#676e73',
            itemBackgroundColor: '#e3e6e8',
            itemColor: '#676e73'
          }
        },
        {
          if: { focus: false, hover: true, pressed: false },
          tokens: {
            groupBackgroundColor: '#f4f4f7',
            groupColor: '#4b286d',
            itemBackgroundColor: '#f4f4f7',
            itemColor: '#4b286d'
          }
        },
        {
          if: { focus: true, pressed: false },
          tokens: {
            groupBorderColor: '#4b286d',
            groupBorderWidth: 1,
            groupColor: '#4b286d',
            itemBorderBottomColor: '#4b286d',
            itemBorderLeftColor: '#4b286d',
            itemBorderRightColor: '#4b286d',
            itemBorderTopColor: '#4b286d',
            itemColor: '#4b286d'
          }
        },
        {
          if: { expanded: true },
          tokens: { groupIcon: PaletteIconCaretUp }
        },
        {
          if: { current: true },
          tokens: {
            groupColor: '#4b286d',
            groupFontName: 'HNforTELUSSA',
            groupFontWeight: '700',
            itemColor: '#4b286d'
          }
        },
        {
          if: { current: true, pressed: true },
          tokens: {
            groupBackgroundColor: '#e3e6e8',
            groupBorderWidth: 1,
            groupColor: '#676e73',
            groupFontName: 'HNforTELUSSA',
            groupFontWeight: '700'
          }
        },
        {
          if: { isChild: true },
          tokens: {
            itemBorderBottomWidth: 1,
            itemBorderLeftColor: '#e3e6e8',
            itemBorderLeftWidth: 4,
            itemBorderTopWidth: 1
          }
        },
        {
          if: { focus: true, isChild: true },
          tokens: {
            itemBorderBottomColor: '#4b286d',
            itemBorderBottomWidth: 1,
            itemBorderLeftColor: '#4b286d',
            itemBorderRightColor: '#4b286d',
            itemBorderRightWidth: 1,
            itemBorderTopColor: '#4b286d',
            itemBorderTopWidth: 1
          }
        },
        {
          if: { hover: true, isChild: true },
          tokens: { itemBorderLeftColor: '#4b286d' }
        },
        {
          if: { current: true, isChild: true },
          tokens: { itemBorderLeftColor: '#4b286d' }
        },
        {
          if: { current: true, pressed: true },
          tokens: { itemColor: '#676e73' }
        },
        {
          if: { isChild: true, pressed: true },
          tokens: {
            itemBorderBottomWidth: 1,
            itemBorderLeftColor: '#676e73',
            itemBorderTopWidth: 1
          }
        }
      ],
      tokens: {
        groupBackgroundColor: 'rgba(0, 0, 0, 0)',
        groupBorderColor: 'rgba(0, 0, 0, 0)',
        groupBorderRadius: 0,
        groupBorderWidth: 1,
        groupColor: '#414547',
        groupFontName: 'HNforTELUSSA',
        groupFontSize: 14,
        groupFontWeight: '400',
        groupHeight: 40,
        groupIcon: PaletteIconCaretDown,
        groupPaddingBottom: 12,
        groupPaddingLeft: 16,
        groupPaddingRight: 16,
        groupPaddingTop: 12,
        itemBackgroundColor: 'rgba(0, 0, 0, 0)',
        itemBorderBottomColor: 'rgba(0, 0, 0, 0)',
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: 'rgba(0, 0, 0, 0)',
        itemBorderLeftWidth: 1,
        itemBorderRadius: 0,
        itemBorderRightColor: 'rgba(0, 0, 0, 0)',
        itemBorderRightWidth: 1,
        itemBorderTopColor: 'rgba(0, 0, 0, 0)',
        itemBorderTopWidth: 1,
        itemBorderWidth: 1,
        itemColor: '#414547',
        itemDisplay: false,
        itemFontName: 'HNforTELUSSA',
        itemFontSize: 14,
        itemFontWeight: '700',
        itemHeight: 40,
        itemOutline: 0,
        itemPaddingBottom: 12,
        itemPaddingLeft: 16,
        itemPaddingRight: 16,
        itemPaddingTop: 12,
        itemTextDecoration: 'none',
        lineHeight: 1.14285714286,
        minHeight: '100%',
        minWidth: '100%',
        shadow: {
          blur: 8,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: false,
          offsetX: 0,
          offsetY: 4,
          spread: 0
        }
      }
    },
    Modal: {
      appearances: {
        maxWidth: {
          description: 'Whether a modal should expand responsively to the maximum of 8 layout columns width',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        width: {
          description: 'The width of the modal',
          type: 'state',
          values: [ 's', 'm', 'l', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            direction: 'column',
            height: '100%',
            marginLeft: 24,
            marginRight: 24,
            paddingBottom: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            direction: 'row',
            maxWidth: 576
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ], width: 's' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 320
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ], width: 'm' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 480
          }
        },
        {
          if: { viewport: [ 'lg', 'xl' ], width: 'l' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 630
          }
        },
        {
          if: { viewport: 'xl', width: 'xl' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 768
          }
        },
        {
          if: { maxWidth: true, viewport: 'md' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 480
          }
        },
        {
          if: { maxWidth: true, viewport: 'lg' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 630
          }
        },
        {
          if: { maxWidth: true, viewport: 'xl' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 768
          }
        }
      ],
      tokens: {
        backdropColor: 'rgba(244, 244, 247, 0.97)',
        backdropOpacity: 1,
        backgroundColor: '#ffffff',
        borderColor: '#e3e6e8',
        borderRadius: 4,
        borderWidth: 0,
        cancelButtonColor: '#2b8000',
        closeIcon: PaletteIconClose,
        closeIconColor: '#414547',
        closeIconSize: 16,
        closePadding: 4,
        containerPaddingBottom: 0,
        containerPaddingLeft: 0,
        containerPaddingRight: 0,
        containerPaddingTop: 0,
        contentPaddingBottom: 0,
        contentPaddingTop: 0,
        direction: 'row',
        footerTopWidth: 0,
        gap: 16,
        headingBorderBottomWidth: 0,
        headingColor: '#414547',
        headingPaddingRight: 24,
        headingPaddingTop: 8,
        height: null,
        marginLeft: 32,
        marginRight: 32,
        maxWidth: '100%',
        paddingBottom: 24,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 24,
        shadow: {
          blur: 8,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: false,
          offsetX: 0,
          offsetY: 4,
          spread: 0
        },
        subHeadingMarginTop: 8
      }
    },
    MultiSelectFilter: {
      appearances: {
        maxHeight: {
          description: 'Whether MultiselectFilter modal should expand responsively to content or a set maximu height',
          type: 'state',
          values: [ true ]
        },
        maxWidth: {
          description: 'Whether MultiselectFilter modal should expand to content or a set maximuh width',
          type: 'state',
          values: [ true ]
        },
        selected: { type: 'state', values: [ true ] },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            buttonDirection: 'column',
            minHeight: '100%',
            minWidth: '100%'
          }
        },
        {
          if: { maxHeight: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
          tokens: { maxHeightSize: 480 }
        },
        {
          if: { maxWidth: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
          tokens: { maxWidthSize: 544 }
        },
        {
          if: { selected: true },
          tokens: {
            buttonIconBackgroundColor: '#f4f4f7',
            labelColor: '#676e73'
          }
        }
      ],
      tokens: {
        buttonBackgroundColor: '#ffffff',
        buttonBackgroundColorSelected: '#ffffff',
        buttonBorderColor: '#b2b9bf',
        buttonDirection: 'row',
        buttonIconBackgroundColor: '#f4f4f7',
        buttonIconPadding: 2,
        buttonIconSize: 16,
        containerBorderColor: '#e3e6e8',
        contentMarginBottom: 32,
        contentMarginLeft: 16,
        contentMarginRight: 16,
        contentMarginTop: 24,
        contentPaddingLeft: 16,
        contentPaddingRight: 16,
        dividerColor: '#e3e6e8',
        headerFontColor: '#414547',
        headerFontName: 'HNforTELUSSA',
        headerFontSize: 16,
        headerFontWeight: '500',
        headerLineHeight: 1.5,
        iconColor: '#414547',
        iconColorSelected: '#414547',
        labelColor: '#676e73',
        labelFontName: 'HNforTELUSSA',
        labelFontSize: 14,
        labelFontWeight: '700',
        labelLineHeight: 1.42857142857,
        labelPaddingBottom: 8,
        labelPaddingLeft: 16,
        labelPaddingRight: 8,
        labelPaddingTop: 8,
        maxHeightSize: 480,
        maxWidthSize: 0,
        minHeight: 0,
        minWidth: 320,
        subHeaderFontName: 'HNforTELUSSA',
        subHeaderFontSize: 14,
        subHeaderFontWeight: '400',
        subHeaderLineHeight: 1.4
      }
    },
    NavigationBar: {
      appearances: {
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#f4f4f7',
            color: '#4b286d',
            fontName: 'HNforTELUSSA',
            fontWeight: '700'
          }
        },
        {
          if: { focus: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#4b286d',
            borderWidth: 2,
            color: '#4b286d',
            outerBorderColor: '#4b286d',
            outerBorderWidth: 2
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: {
            backgroundColor: '#4b286d',
            borderColor: '#4b286d',
            color: '#ffffff'
          }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#7c53a5',
            color: '#4b286d'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#e3e6e8',
            borderColor: '#7c53a5',
            borderWidth: 1,
            color: '#4b286d'
          }
        },
        {
          if: { viewport: [ 'xs', 'sm', 'md' ] },
          tokens: { textAlign: 'space-between', width: 288 }
        },
        {
          if: { expanded: true },
          tokens: { icoMenu: PaletteIconCaretUp }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#ffffff',
        borderColor: '#ffffff',
        borderRadius: 32,
        borderWidth: 1,
        color: '#414547',
        fontName: 'HNforTELUSSA',
        fontSize: 14,
        fontWeight: '400',
        icoMenu: PaletteIconCaretDown,
        lineHeight: 1.14285714286,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderWidth: 1,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        shadow: null,
        textAlign: 'center',
        width: 0
      }
    },
    Notification: {
      appearances: {
        style: {
          type: 'variant',
          values: [ 'system', 'success', 'warning', 'error', 'subtle' ]
        },
        system: { type: 'state', values: [ true ] },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { system: true },
          tokens: {
            borderLeftWidth: 0,
            borderRadius: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            iconGap: 8
          }
        },
        {
          if: { style: 'system' },
          tokens: {
            borderLeftWidth: 0,
            borderRadius: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            iconGap: 8
          }
        },
        {
          if: { style: 'subtle' },
          tokens: {
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            borderRadius: 6,
            borderRightWidth: 0,
            borderTopWidth: 0,
            iconGap: 8
          }
        },
        {
          if: { style: 'success' },
          tokens: {
            backgroundColor: '#f4f9f2',
            borderColor: '#2b8000',
            icon: PaletteIconStatusSuccess,
            iconColor: '#2b8000'
          }
        },
        {
          if: { validation: 'success' },
          tokens: {
            backgroundColor: '#f4f9f2',
            borderColor: '#2b8000',
            icon: PaletteIconStatusSuccess,
            iconColor: '#2b8000'
          }
        },
        {
          if: { style: 'warning' },
          tokens: {
            backgroundColor: '#fff9ee',
            borderColor: '#c77539',
            dismissIcon: null,
            icon: PaletteIconStatusWarning,
            iconColor: '#c77539'
          }
        },
        {
          if: { validation: 'warning' },
          tokens: {
            backgroundColor: '#fff9ee',
            borderColor: '#c77539',
            dismissIcon: null,
            icon: PaletteIconStatusWarning,
            iconColor: '#c77539'
          }
        },
        {
          if: { style: 'error' },
          tokens: {
            backgroundColor: '#fff6f8',
            borderColor: '#e12339',
            dismissIcon: null,
            icon: PaletteIconStatusError,
            iconColor: '#e12339'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            backgroundColor: '#fff6f8',
            borderColor: '#e12339',
            dismissIcon: null,
            icon: PaletteIconStatusError,
            iconColor: '#e12339'
          }
        },
        {
          if: { validation: 'feature' },
          tokens: {
            backgroundColor: '#4b286d',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#ffffff',
            dismissIcon: null,
            icon: PaletteIconTagFilled,
            iconColor: '#ffffff'
          }
        }
      ],
      tokens: {
        backgroundColor: '#efedff',
        borderBottomWidth: 1,
        borderColor: '#7c53a5',
        borderLeftWidth: 1,
        borderRadius: 6,
        borderRightWidth: 1,
        borderTopWidth: 1,
        color: '#414547',
        containerPaddingLeft: 0,
        containerPaddingRight: 0,
        dismissButtonGap: 24,
        dismissIcon: PaletteIconClose,
        dismissIconColor: '#676e73',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        icon: PaletteIconStatusInfo,
        iconColor: '#4b286d',
        iconGap: 8,
        iconSize: 24,
        justifyContent: 'flex-start',
        lineHeight: 1.5,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12
      }
    },
    OrderedList: {
      appearances: {
        compact: {
          description: 'When true it will reduce the line height of the list item.',
          type: 'variant',
          values: [ true ]
        },
        size: {
          description: 'Indicates list item text size.',
          type: 'variant',
          values: [ 'large', 'medium', 'small' ]
        }
      },
      rules: [
        {
          if: { size: 'large' },
          tokens: { itemFontSize: 20, itemLineHeight: 1.6 }
        },
        {
          if: { size: 'small' },
          tokens: { itemFontSize: 14, itemLineHeight: 1.42857142857 }
        },
        { if: { compact: true }, tokens: { itemLineHeight: 1.25 } },
        {
          if: { compact: true, size: 'small' },
          tokens: { itemLineHeight: 1.14285714286 }
        },
        {
          if: { compact: true, size: 'large' },
          tokens: { itemLineHeight: 1.2 }
        }
      ],
      tokens: {
        headerFontName: 'HNforTELUSSA',
        headerFontWeight: '700',
        interItemMargin: 8,
        itemBulletContainerWidth: 20,
        itemBulletHeight: 4,
        itemBulletTextAlign: 'right',
        itemBulletWidth: 4,
        itemColor: null,
        itemFontName: 'HNforTELUSSA',
        itemFontSize: 16,
        itemFontWeight: '400',
        itemLineHeight: 1.5,
        itemMarginTop: 0,
        itemPaddingTop: 0,
        itemTextColor: '#414547',
        listGutter: 8
      }
    },
    Pagination: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { truncateAbove: 6 }
        }
      ],
      tokens: {
        borderBottomWidth: 0,
        borderColor: '#676e73',
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        color: '#676e73',
        ellipsisBorderBottomWidth: 0,
        ellipsisBorderLeftWidth: 0,
        ellipsisBorderRightWidth: 0,
        ellipsisBorderTopWidth: 0,
        ellipsisHeight: null,
        ellipsisPadding: 0,
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        gap: 2,
        lineHeight: 1.5,
        truncateAbove: 4
      }
    },
    PaginationPageButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { borderColor: '#676e73', textLine: 'none' }
        },
        {
          if: { focus: true },
          tokens: {
            borderBottomWidth: 3,
            borderColor: '#676e73',
            borderLeftWidth: 3,
            borderRightWidth: 3,
            borderTopWidth: 3
          }
        },
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#676e73',
            color: '#ffffff',
            textLine: 'none'
          }
        },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#676e73', color: '#ffffff' }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottomWidth: 1,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderLeftWidth: 1,
        borderRadius: 32,
        borderRightWidth: 1,
        borderTopWidth: 1,
        color: '#676e73',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        height: 32,
        lineHeight: 1.5,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 4,
        outerBorderWidth: 4,
        paddingBottom: 4,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4,
        textAlign: 'center',
        textLine: 'underline',
        width: 32
      }
    },
    PaginationSideButton: {
      appearances: {
        compact: {
          description: 'Determines if the "Next" and "Previous" labels should be omitted',
          type: 'state',
          values: [ true ]
        },
        direction: {
          description: "Determines which way does the button navigate in Pagination's context",
          type: 'state',
          values: [ 'previous', 'next' ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        { if: { compact: true }, tokens: { displayLabel: false } },
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            borderRadius: 32,
            displayLabel: false,
            paddingBottom: 4,
            paddingTop: 4,
            width: 32
          }
        },
        {
          if: { hover: true },
          tokens: {
            iconDisplace: 4,
            outerBorderColor: '#676e73',
            outerBorderWidth: 1,
            textLine: 'none'
          }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#676e73', outerBorderWidth: 3 }
        },
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#676e73',
            color: '#ffffff',
            textLine: 'none'
          }
        },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#676e73', color: '#ffffff' }
        },
        {
          if: { direction: 'previous' },
          tokens: { icon: PaletteIconArrowLeft }
        },
        {
          if: { direction: 'next' },
          tokens: { icon: PaletteIconArrowRight }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottomWidth: 0,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderLeftWidth: 0,
        borderRadius: 4,
        borderRightWidth: 0,
        borderTopWidth: 0,
        color: '#676e73',
        displayLabel: true,
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        height: null,
        icon: null,
        iconDisplace: 0,
        iconSize: 24,
        lineHeight: 1.5,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 1,
        paddingBottom: 4,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4,
        textAlign: 'center',
        textLine: 'none',
        width: null
      }
    },
    PreviewCard: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { borderWidth: 2 } },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#f4f4f7' }
        },
        {
          if: { focus: true },
          tokens: {
            outerBorderColor: '#676e73',
            outerBorderGap: 2,
            outerBorderWidth: 2
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#e3e6e8',
        borderRadius: 6,
        borderWidth: 1,
        flex: 1,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        separatorColor: '#b2b9bf'
      }
    },
    PriceLockup: {
      appearances: {
        price: { type: 'variant', values: [ 'default', 'baseline' ] },
        size: {
          type: 'variant',
          values: [ 'micro', 'small', 'medium', 'large' ]
        },
        strikeThrough: { type: 'variant', values: [ true ] },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { size: 'micro' },
          tokens: {
            amountFontSize: 28,
            bottomTextFontSize: 14,
            bottomTextLineHeight: 1.42857142857,
            centsFontSize: 16,
            centsLineHeight: 1.33333333333,
            currencySymbolFontSize: 16,
            currencySymbolLineHeight: 1.25,
            rateFontSize: 14,
            rateLineHeight: 1.14285714286,
            strikeThroughPosition: 15,
            topTextFontSize: 14,
            topTextLineHeight: 1.42857142857
          }
        },
        {
          if: { size: 'small' },
          tokens: {
            amountFontSize: 28,
            bottomTextFontSize: 14,
            bottomTextLineHeight: 1.42857142857,
            centsFontSize: 16,
            centsLineHeight: 1.33333333333,
            currencySymbolFontSize: 16,
            currencySymbolLineHeight: 1.25,
            rateFontSize: 14,
            rateLineHeight: 1.14285714286,
            strikeThroughPosition: 15,
            topTextFontSize: 14,
            topTextLineHeight: 1.42857142857
          }
        },
        {
          if: { size: 'large' },
          tokens: {
            amountFontSize: 64,
            bottomTextFontSize: 16,
            bottomTextLineHeight: 1.5,
            centsFontSize: 36,
            centsLineHeight: 1.125,
            currencySymbolFontSize: 36,
            currencySymbolLineHeight: 1.125,
            rateFontSize: 20,
            rateLineHeight: 1.6,
            strikeThroughHeight: 3,
            strikeThroughPosition: 35,
            topTextFontSize: 16,
            topTextLineHeight: 1.5
          }
        },
        {
          if: { size: 'large', viewport: [ 'lg', 'xl' ] },
          tokens: {
            bottomTextFontSize: 20,
            bottomTextLineHeight: 1.6,
            topTextFontSize: 20,
            topTextLineHeight: 1.6
          }
        },
        {
          if: { strikeThrough: true },
          tokens: { fontColor: '#676e73', footnoteLinkColor: '#676e73' }
        },
        {
          if: { price: 'baseline' },
          tokens: {
            centsFontName: 'HNforTELUSSA',
            centsFontSize: 40,
            centsFontWeight: '300',
            centsLineHeight: 1
          }
        },
        {
          if: { price: 'baseline', size: 'micro' },
          tokens: {
            centsFontName: 'HNforTELUSSA',
            centsFontSize: 28,
            centsFontWeight: '300',
            centsLineHeight: 1
          }
        },
        {
          if: { price: 'baseline', size: 'small' },
          tokens: {
            centsFontName: 'HNforTELUSSA',
            centsFontSize: 28,
            centsFontWeight: '300',
            centsLineHeight: 1
          }
        },
        {
          if: { price: 'baseline', size: 'large' },
          tokens: {
            centsFontName: 'HNforTELUSSA',
            centsFontSize: 64,
            centsFontWeight: '300',
            centsLineHeight: 1
          }
        }
      ],
      tokens: {
        alignItemsText: 'flex-start',
        amountFontName: 'HNforTELUSSA',
        amountFontSize: 40,
        amountFontWeight: '300',
        amountLetterSpacing: -0.039,
        amountLineHeight: 1,
        bottomLinksMarginLeft: 4,
        bottomTextFontSize: 16,
        bottomTextLineHeight: 1.5,
        bottomTextMarginTop: 4,
        centsFontName: 'HNforTELUSSA',
        centsFontSize: 20,
        centsFontWeight: '400',
        centsLineHeight: 1.2,
        centsPaddingTop: 0,
        currencySymbolFontName: 'HNforTELUSSA',
        currencySymbolFontSize: 20,
        currencySymbolFontWeight: '400',
        currencySymbolLineHeight: 1.2,
        currencySymbolPaddingTop: 0,
        dividerColor: '#b2b9bf',
        fontColor: '#414547',
        fontName: 'HNforTELUSSA',
        fontWeight: '700',
        footnoteGap: 4,
        footnoteLinkColor: '#414547',
        footnoteLinkFontName: 'HNforTELUSSA',
        footnoteLinkFontSize: 14,
        footnoteLinkFontWeight: '400',
        footnoteLinkLineHeight: 1.42857142857,
        footnoteMarginTop: 4,
        priceMarginBottom: 8,
        rateFontName: 'HNforTELUSSA',
        rateFontSize: 16,
        rateFontWeight: '400',
        rateLineHeight: 1.25,
        strikeThroughColor: '#676e73',
        strikeThroughHeight: 2,
        strikeThroughPosition: 22,
        topTextFontName: 'HNforTELUSSA',
        topTextFontSize: 16,
        topTextFontWeight: '700',
        topTextLineHeight: 1.5,
        topTextMarginBottom: 4
      }
    },
    ProductCard: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm', 'md' ] },
          tokens: { borderWidth: 0, paddingHorizontal: 24, paddingVertical: 0 }
        }
      ],
      tokens: {
        borderColor: '#e3e6e8',
        borderRadius: 6,
        borderStyle: 'solid',
        borderWidth: 1,
        paddingHorizontal: 24,
        paddingVertical: 24,
        selectedButtonIcon: PaletteIconCheckbold
      }
    },
    Progress: {
      appearances: {
        size: { type: 'variant', values: [ 'mini' ] },
        style: {
          description: 'Configure `style` variant for `Progress`',
          type: 'variant',
          values: [ 'inverse' ]
        }
      },
      rules: [
        { if: { size: 'mini' }, tokens: { height: 8 } },
        {
          if: { style: 'inverse' },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderColor: 'rgba(255, 255, 255, 0.6)',
            shadow: {
              blur: 2,
              color: 'rgba(0, 0, 0, 0.1)',
              inset: true,
              offsetX: 0,
              offsetY: 2,
              spread: 0
            }
          }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderColor: '#b2b9bf',
        borderRadius: 12,
        borderWidth: 1,
        height: 16,
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: true,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        }
      }
    },
    ProgressBar: {
      appearances: {
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        negative: { type: 'variant', values: [ true ] },
        style: {
          description: 'Configure `style` variant for `ProgressBar`',
          type: 'variant',
          values: [ 'subtle', 'inverse', 'inactive', 'negative' ]
        }
      },
      rules: [
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#b2b9bf',
            gradient: null,
            outlineColor: '#2c2e30',
            shadow: null
          }
        },
        {
          if: { negative: true },
          tokens: {
            backgroundColor: '#c12335',
            gradient: null,
            outlineColor: '#c12335',
            shadow: null
          }
        },
        {
          if: { style: 'inactive' },
          tokens: {
            backgroundColor: '#b2b9bf',
            gradient: null,
            outlineColor: '#2c2e30',
            shadow: null
          }
        },
        {
          if: { style: 'negative' },
          tokens: {
            backgroundColor: '#c12335',
            gradient: null,
            outlineColor: '#c12335',
            shadow: null
          }
        },
        {
          if: { style: 'subtle' },
          tokens: {
            backgroundColor: '#676e73',
            gradient: null,
            outlineColor: '#676e73'
          }
        },
        {
          if: { style: 'inverse' },
          tokens: {
            backgroundColor: '#ffffff',
            gradient: null,
            outlineColor: '#ffffff'
          }
        }
      ],
      tokens: {
        backgroundColor: '#2b8000',
        borderRadius: 12,
        gradient: {
          angle: 135,
          stops: [
            { color: '#00784a', hint: 0.75, stop: 0 },
            { color: '#66cc00', stop: 1 }
          ],
          type: 'linear'
        },
        outlineColor: '#2b8000',
        outlineWidth: 1,
        shadow: {
          blur: 1,
          color: 'rgba(255, 255, 255, 0.8)',
          inset: true,
          offsetX: 0,
          offsetY: 1,
          spread: 0
        }
      }
    },
    QuantitySelector: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        disabled: { type: 'variant', values: [ true ] },
        focus: { type: 'variant', values: [ true ] },
        hover: { type: 'variant', values: [ true ] },
        pressed: { type: 'variant', values: [ true ] }
      },
      rules: [
        {
          if: { alternative: true },
          tokens: { paddingBottom: 8, paddingTop: 8 }
        },
        {
          if: { hover: true },
          tokens: { inputBackgroundColor: '#f4f4f7' }
        },
        {
          if: { disabled: true },
          tokens: { inputBackgroundColor: '#fafafa', textColor: '#b2b9bf' }
        },
        {
          if: { pressed: true },
          tokens: { inputBackgroundColor: '#b2b9bf' }
        },
        {
          if: { focus: true },
          tokens: { inputBorderColor: '#676e73', inputBorderWidth: 3 }
        }
      ],
      tokens: {
        fontSize: 16,
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#676e73',
        inputBorderWidth: 1,
        inputWidth: 64,
        lineHeight: 1.5,
        padding: 12,
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12,
        textColor: '#414547'
      }
    },
    QuantitySelectorSideButton: {
      appearances: {
        alternative: { type: 'variant', values: [ true, false ] },
        decrease: { type: 'variant', values: [ true ] },
        disabled: { type: 'variant', values: [ true ] },
        focus: { type: 'variant', values: [ true ] },
        hover: { type: 'variant', values: [ true ] },
        increase: { type: 'variant', values: [ true ] },
        pressed: { type: 'variant', values: [ true ] }
      },
      rules: [
        { if: { hover: true }, tokens: { backgroundColor: '#f4f4f7' } },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#b2b9bf', iconColor: '#676e73' }
        },
        {
          if: { decrease: true },
          tokens: {
            borderBottomLeftRadius: 4,
            borderRightWidth: 0,
            borderTopLeftRadius: 4,
            icon: PaletteIconSubtract
          }
        },
        {
          if: { increase: true },
          tokens: {
            borderBottomRightRadius: 4,
            borderLeftWidth: 0,
            borderTopRightRadius: 4,
            icon: PaletteIconAdd
          }
        },
        {
          if: { focus: true, increase: true },
          tokens: {
            borderBottomWidth: 3,
            borderLeftWidth: 2,
            borderRightWidth: 3,
            borderTopWidth: 3
          }
        },
        {
          if: { decrease: true, focus: true },
          tokens: {
            borderBottomWidth: 3,
            borderLeftWidth: 3,
            borderRightWidth: 2,
            borderTopWidth: 3
          }
        },
        {
          if: { disabled: true },
          tokens: { backgroundColor: '#fafafa', iconColor: '#e3e6e8' }
        },
        {
          if: { alternative: true },
          tokens: { paddingBottom: 12, paddingTop: 12 }
        },
        {
          if: { alternative: true, increase: true },
          tokens: { borderBottomRightRadius: 24, borderTopRightRadius: 24 }
        },
        {
          if: { alternative: true, decrease: true },
          tokens: { borderBottomLeftRadius: 24, borderTopLeftRadius: 24 }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomWidth: 1,
        borderColor: '#676e73',
        borderLeftWidth: 1,
        borderRadius: 0,
        borderRightWidth: 1,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderTopWidth: 1,
        borderWidth: 1,
        icon: null,
        iconColor: '#414547',
        iconSize: 16,
        padding: 16,
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16
      }
    },
    QuickLinks: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { card: false, dividers: true, list: false }
        }
      ],
      tokens: {
        card: true,
        dividers: true,
        list: true,
        stackGap: 2,
        stackJustify: 'center',
        stackSpace: 4
      }
    },
    QuickLinksButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { borderWidth: 3 } },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#b2b9bf', borderWidth: 3 }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#676e73' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { borderWidth: 1 }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#ffffff',
        borderColor: '#676e73',
        borderRadius: 32,
        borderWidth: 1,
        color: '#676e73',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '700',
        icon: null,
        iconColor: '#4b286d',
        iconSize: 24,
        iconSpace: 2,
        lineHeight: 1.5,
        minWidth: 144,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 28,
        paddingRight: 28,
        paddingTop: 12,
        shadow: null,
        textAlign: 'center',
        width: null
      }
    },
    QuickLinksCard: {
      appearances: {},
      rules: [],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderRadius: 6,
        borderWidth: 1,
        flex: 1,
        minWidth: null,
        paddingBottom: 8,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 8,
        shadow: null
      }
    },
    QuickLinksFeature: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [ { if: { viewport: 'xs' }, tokens: { stackSpace: 4 } } ],
      tokens: { stackGap: 5, stackJustify: 'center', stackSpace: 5 }
    },
    QuickLinksFeatureItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: 'xl' },
          tokens: { contentMaxDimension: 184, imageDimension: 168 }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#2b8000', textLine: 'none' }
        },
        {
          if: { hover: true },
          tokens: {
            color: '#2b8000',
            imageDimension: 140,
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, viewport: 'xl' },
          tokens: { imageDimension: 184 }
        },
        {
          if: { pressed: true },
          tokens: { color: '#1f5c09', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { color: '#1f5c09', outerBorderColor: '#1f5c09' }
        }
      ],
      tokens: {
        color: '#2c2e30',
        contentAlignItems: 'center',
        contentDirection: 'column',
        contentMaxDimension: 168,
        contentSpace: 3,
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '700',
        gap: 5,
        imageDimension: 128,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        textAlign: 'center',
        textLine: 'none'
      }
    },
    QuickLinksList: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            itemFontColor: '#4b286d',
            itemUnderline: 'underline'
          }
        },
        {
          if: { focus: true },
          tokens: {
            backgroundColor: '#e3e6e8',
            itemFontColor: '#414547',
            itemUnderline: 'underline'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#b2b9bf',
            dividerColor: '#b2b9bf',
            itemFontColor: '#676e73',
            itemIconColor: '#676e73',
            itemUnderline: 'underline'
          }
        }
      ],
      tokens: {
        backgroundColor: null,
        dividerColor: '#676e73',
        dividerSize: 1,
        iconMarginTop: 0,
        interItemMargin: 0,
        interItemMarginWithDivider: 0,
        itemBulletColor: '#4b286d',
        itemBulletContainerAlign: 'center',
        itemBulletContainerWidth: 16,
        itemBulletHeight: 4,
        itemBulletWidth: 4,
        itemFontColor: '#676e73',
        itemFontName: 'HNforTELUSSA',
        itemFontSize: 16,
        itemFontWeight: '700',
        itemIconColor: '#4b286d',
        itemIconSize: 24,
        itemLineHeight: 1.5,
        itemUnderline: 'none',
        listGutter: 16,
        paddingBottom: 12,
        paddingLeft: null,
        paddingRight: null,
        paddingTop: 12
      }
    },
    Radio: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        { if: { error: true }, tokens: {} },
        {
          if: { hover: true },
          tokens: { outerBorderColor: '#e3e6e8' }
        },
        {
          if: { focus: true },
          tokens: { inputBorderColor: '#7c53a5', inputBorderWidth: 3 }
        },
        {
          if: { inactive: true },
          tokens: {
            inputBackgroundColor: '#e3e6e8',
            inputBorderColor: 'rgba(0, 0, 0, 0)',
            labelColor: '#676e73'
          }
        },
        {
          if: { checked: true, inactive: true },
          tokens: {
            checkedBackgroundColor: '#b2b9bf',
            inputBackgroundColor: '#ffffff',
            inputBorderColor: '#b2b9bf',
            labelColor: '#676e73'
          }
        }
      ],
      tokens: {
        checkedBackgroundColor: '#7c53a5',
        checkedSize: 12,
        containerBackgroundColor: 'rgba(0, 0, 0, 0)',
        containerBorderRadius: 0,
        containerOpacity: 1,
        containerPaddingBottom: 0,
        containerPaddingLeft: 0,
        containerPaddingRight: 0,
        containerPaddingTop: 0,
        containerShadow: null,
        descriptionFontName: 'HNforTELUSSA',
        descriptionFontSize: 14,
        descriptionFontWeight: '400',
        descriptionLineHeight: 1.42857142857,
        descriptionMarginLeft: null,
        icon: null,
        iconBackgroundColor: 'rgba(0, 0, 0, 0)',
        iconColor: 'rgba(0, 0, 0, 0)',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#676e73',
        inputBorderWidth: 1,
        inputOutlineColor: 'rgba(0, 0, 0, 0)',
        inputOutlineWidth: 0,
        inputSize: 20,
        labelColor: '#414547',
        labelFontName: 'HNforTELUSSA',
        labelFontSize: 16,
        labelFontWeight: '400',
        labelLineHeight: 1.5,
        labelMarginLeft: 8,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 2
      }
    },
    RadioCard: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: {
            fontSize: 24,
            lineHeight: 1.33333333333,
            paddingBottom: 24,
            paddingLeft: 16,
            paddingRight: 24,
            paddingTop: 16
          }
        },
        {
          if: { hover: true },
          tokens: {
            borderColor: '#676e73',
            outerBorderColor: '#e3e6e8',
            radioOuterBorderColor: '#e3e6e8',
            radioOuterBorderWidth: 2
          }
        },
        {
          if: { focus: true },
          tokens: {
            outerBorderColor: '#676e73',
            outerBorderGap: 2,
            radioInputBorderColor: '#7c53a5',
            radioInputBorderWidth: 3
          }
        },
        {
          description: 'Pressed state matches hover state plus light grey background',
          if: { pressed: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#676e73',
            outerBorderColor: '#e3e6e8',
            outerBorderGap: 0,
            radioInputBorderColor: '#676e73',
            radioInputBorderWidth: 1,
            radioOuterBorderColor: '#e3e6e8',
            radioOuterBorderWidth: 3
          }
        },
        { if: { checked: true }, tokens: { borderColor: '#7c53a5' } },
        {
          if: { checked: true, hover: true },
          tokens: { borderColor: '#4b286d' }
        },
        {
          if: { error: true },
          tokens: {
            borderColor: '#e12339',
            color: '#e12339',
            radioInputBorderColor: '#e12339'
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#676e73',
            radioCheckedBackgroundColor: '#676e73',
            radioInputBackgroundColor: '#b2b9bf',
            radioInputBorderColor: 'transparent',
            radioInputSize: 12,
            radioOuterBorderColor: '#b2b9bf',
            radioOuterBorderGap: 2,
            radioOuterBorderWidth: 1
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderRadius: 6,
        borderWidth: 1,
        color: '#2c2e30',
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 1,
        contentJustifyContent: 'flex-start',
        contentSpace: 2,
        flex: 1,
        fontName: 'HNforTELUSSA',
        fontSize: 20,
        fontWeight: '500',
        letterSpacing: 0,
        lineHeight: 1.4,
        minWidth: 264,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 2,
        paddingBottom: 16,
        paddingLeft: 10,
        paddingRight: 16,
        paddingTop: 16,
        radioCheckedBackgroundColor: '#7c53a5',
        radioCheckedSize: 12,
        radioInputBackgroundColor: '#ffffff',
        radioInputBorderColor: '#676e73',
        radioInputBorderWidth: 1,
        radioInputOutlineColor: 'rgba(0, 0, 0, 0)',
        radioInputOutlineWidth: 0,
        radioInputSize: 20,
        radioOuterBorderColor: 'transparent',
        radioOuterBorderGap: 0,
        radioOuterBorderWidth: 0,
        radioSpace: 2,
        shadow: null,
        textTransform: 'none'
      }
    },
    RadioCardGroup: {
      appearances: {
        fullWidth: {
          description: 'Makes cards always occupy the full width of the parent, regardless of viewport',
          type: 'variant',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { fullWidth: null, viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { direction: 'row', space: 5 }
        }
      ],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        direction: 'column',
        fieldSpace: 3,
        outlineOffset: 8,
        outlineWidth: 1,
        showIcon: true,
        space: 3
      }
    },
    RadioGroup: {
      appearances: {},
      rules: [],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        fieldSpace: 2,
        outlineOffset: 8,
        outlineWidth: 1,
        showIcon: true,
        space: 2
      }
    },
    Ribbon: {
      appearances: {
        purpose: {
          type: 'variant',
          values: [ 'offer', 'default', 'editorial', 'subtle' ]
        },
        wrap: { type: 'variant', values: [ true ] }
      },
      rules: [
        {
          if: { purpose: 'editorial' },
          tokens: {
            backgroundColor: '#676e73',
            curveAfterBackgroundColor: '#676e73',
            curveBackgroundColor: '#2c2e30'
          }
        },
        {
          if: { purpose: 'offer' },
          tokens: {
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { wrap: true },
          tokens: { paddingLeft: 24, paddingRight: 24 }
        },
        {
          if: { purpose: 'subtle' },
          tokens: {
            backgroundColor: '#7c53a5',
            curveAfterBackgroundColor: '#7c53a5'
          }
        }
      ],
      tokens: {
        backgroundColor: '#613889',
        borderRadius: 4,
        borderRadiusBottomLeft: null,
        borderRadiusBottomRight: null,
        boxShadowColor: 'rgba(0, 0, 0, 0.1)',
        boxShadowPaddingBottom: 2,
        boxShadowPaddingLeft: 0,
        boxShadowPaddingRight: 2,
        boxShadowPaddingTop: 0,
        curveAfterBackgroundColor: '#613889',
        curveAfterHeight: 4,
        curveAfterRadius: 0,
        curveAfterWidth: 8,
        curveBackgroundColor: '#3f2a54',
        curveHeight: 10,
        curveMarginTop: 4,
        curveWidth: 8,
        fontColor: '#ffffff',
        fontName: 'HNforTELUSSA',
        fontSize: 12,
        fontWeight: '700',
        gradient: null,
        lineHeight: 1.33333333333,
        paddingBottom: 4,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4
      }
    },
    Search: {
      appearances: {
        focus: {
          description: 'Focus states for some input elements are well supported across web, RN, ios and android',
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { hover: true, inactive: null },
          tokens: { outerBorderWidth: 2 }
        },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#7c53a5',
            borderWidth: 3,
            mobileBorderWidth: 1,
            outerBorderWidth: 0
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#f4f4f7',
            color: '#676e73',
            placeholderColor: '#676e73'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#676e73',
        borderRadius: 32,
        borderWidth: 1,
        buttonsGap: 2,
        clearButtonIcon: PaletteIconTimes,
        color: '#414547',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        iconLeftColor: '#676e73',
        iconLeftSize: 20,
        lineHeight: 1.5,
        mobileBorderWidth: 1,
        outerBackgroundColor: 'transparent',
        outerBorderColor: '#e3e6e8',
        outerBorderRadius: 32,
        outerBorderWidth: 0,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 8,
        paddingTop: 12,
        placeholderColor: '#414547',
        submitButtonIcon: PaletteIconSearchBold
      }
    },
    SearchButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        priority: { description: '', type: 'variant', values: [ 'high' ] }
      },
      rules: [
        {
          if: { priority: 'high' },
          tokens: {
            backgroundColor: '#4b286d',
            iconColor: '#ffffff',
            mobileBackgroundColor: '#4b286d'
          }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#7c53a5',
            borderWidth: 0,
            iconColor: '#ffffff',
            mobileBackgroundColor: '#7c53a5'
          }
        },
        {
          if: { focus: true },
          tokens: {
            backgroundColor: 'transparent',
            borderColor: '#4b286d',
            borderWidth: 3,
            iconColor: '#4b286d',
            mobileBackgroundColor: 'transparent'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#3f2a54',
            borderWidth: 0,
            iconColor: '#ffffff',
            mobileBackgroundColor: '#3f2a54'
          }
        },
        {
          if: { inactive: true, priority: 'high' },
          tokens: {
            backgroundColor: '#e3e6e8',
            borderWidth: 0,
            iconColor: '#676e73',
            mobileBackgroundColor: '#e3e6e8'
          }
        },
        {
          if: { inactive: true, priority: null },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            iconColor: 'rgba(0, 0, 0, 0)',
            mobileBackgroundColor: 'rgba(0, 0, 0, 0)'
          }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        borderWidth: 0,
        iconColor: '#676e73',
        iconSize: 20,
        mobileBackgroundColor: '#f4f4f7',
        opacity: 1,
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
        shadow: null
      }
    },
    Select: {
      appearances: {
        active: { type: 'state', values: [ true ] },
        focus: {
          description: 'Focus states for some input elements are well supported across web, RN, ios and android',
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { outerBorderColor: '#e3e6e8' }
        },
        {
          if: { focus: true },
          tokens: { borderColor: '#7c53a5', borderWidth: 3 }
        },
        {
          if: { validation: 'success' },
          tokens: {
            borderColor: '#2b8000',
            feedbackBackgroundColor: '#f4f9f2',
            validationIcon: PaletteIconStatusSuccess,
            validationIconColor: '#2b8000'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            borderColor: '#e12339',
            feedbackBackgroundColor: '#fff6f8',
            validationIcon: PaletteIconStatusError,
            validationIconColor: '#e12339'
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            borderColor: '#f4f4f7',
            color: '#676e73',
            icon: null
          }
        },
        {
          if: { active: true },
          tokens: { icon: PaletteIconCaretUp }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#676e73',
        borderRadius: 4,
        borderWidth: 1,
        color: '#414547',
        feedbackBackgroundColor: '#f4f4f7',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        height: 48,
        icon: PaletteIconCaretDown,
        iconColor: '#414547',
        iconSize: 20,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        validationIcon: null,
        validationIconColor: 'rgba(0, 0, 0, 0)',
        validationIconSize: 20
      }
    },
    SideNav: {
      appearances: {},
      rules: [],
      tokens: { borderColor: '#b2b9bf', borderStyle: 'solid', borderWidth: 1 }
    },
    SideNavItem: {
      appearances: {
        active: {
          description: 'Used to mark currently active Item or and ItemGroup containing the currently active Item',
          type: 'state',
          values: [ true, false ]
        },
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        type: {
          description: '`parent` being the toggle button for an ItemsGroup, and `child` an element of the ItemGroup',
          type: 'state',
          values: [ 'child', 'parent' ]
        }
      },
      rules: [
        {
          if: { active: true },
          tokens: {
            accentBackgroundColor: '#4b286d',
            backgroundColor: '#f4f4f7',
            color: '#4b286d',
            fontName: 'HNforTELUSSA',
            fontWeight: '700',
            paddingLeft: 12
          }
        },
        {
          if: { type: 'child' },
          tokens: {
            accentBackgroundColor: '#f4f4f7',
            accentOffset: 16,
            borderWidth: 0,
            fontSize: 14,
            lineHeight: 1.45,
            paddingLeft: 36
          }
        },
        {
          if: { active: true, type: 'parent' },
          tokens: { color: '#4b286d', paddingLeft: 12 }
        },
        {
          if: { active: true, expanded: true, type: 'parent' },
          tokens: {
            accentBackgroundColor: 'rgba(0, 0, 0, 0)',
            color: '#4b286d',
            fontName: 'HNforTELUSSA',
            fontWeight: '400',
            paddingLeft: 16
          }
        },
        {
          if: { hover: true },
          tokens: { backgroundColor: '#f4f4f7', color: '#4b286d' }
        },
        {
          if: { focus: true },
          tokens: { backgroundColor: '#f4f4f7', color: '#4b286d' }
        },
        {
          if: { active: true, type: 'child' },
          tokens: {
            accentBackgroundColor: '#4b286d',
            accentPadding: 16,
            backgroundColor: '#f4f4f7'
          }
        },
        {
          if: { active: false, hover: true, type: 'child' },
          tokens: {
            accentBackgroundColor: '#ffffff',
            accentOffset: 0,
            accentWidth: 16,
            color: '#414547'
          }
        }
      ],
      tokens: {
        accentBackgroundColor: 'rgba(0, 0, 0, 0)',
        accentOffset: 0,
        accentPadding: 0,
        accentWidth: 4,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#b2b9bf',
        borderStyle: 'solid',
        borderWidth: 1,
        color: '#414547',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        justifyContent: 'space-between',
        lineHeight: 1.5,
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16
      }
    },
    SideNavItemsGroup: {
      appearances: {
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { expanded: true },
          tokens: { icon: PaletteIconCaretUp }
        }
      ],
      tokens: {
        collapseDuration: 250,
        contentPaddingBottom: 0,
        contentPaddingLeft: 0,
        contentPaddingRight: 0,
        contentPaddingTop: 0,
        expandDuration: 300,
        icon: PaletteIconCaretDown,
        iconColor: '#2b8000',
        iconGap: 8,
        iconPosition: 'right',
        iconSize: 24,
        justifyContent: 'space-between',
        verticalAlign: 'middle'
      }
    },
    Skeleton: {
      appearances: {},
      rules: [],
      tokens: {
        animationDuration: 2000,
        baseWidth: 40,
        characters: 10,
        color: '#b2b9bf',
        lineRadius: 99999999999999,
        radius: 99999999999999,
        secondColor: '#e3e6e8',
        size: 3,
        spaceBetweenLines: 2,
        squareRadius: 4
      }
    },
    SkipLink: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { focus: true, pressed: true },
          tokens: { color: '#163e06', outlineColor: '#163e06' }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 4,
        color: '#2b8000',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        lineHeight: 1.5,
        outlineColor: '#2b8000',
        outlineOffset: 0,
        outlineStyle: 'solid',
        outlineWidth: 2,
        paddingHorizontal: 2,
        paddingVertical: 2,
        textLine: 'underline'
      }
    },
    Spinner: {
      appearances: { size: { type: 'variant', values: [ 'small' ] } },
      rules: [ { if: { size: 'small' }, tokens: { size: 24, thickness: 2 } } ],
      tokens: {
        fullScreenOverLayBackground: 'rgba(255, 255, 255, 0.97)',
        size: 48,
        thickness: 4
      }
    },
    SplashButton: {
      appearances: {
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { buttonContentChildrenBackground: 'rgba(0, 0, 0, 0.8)' }
        }
      ],
      tokens: {
        buttonContentBackground: 'rgba(0, 0, 0, 0.6)',
        buttonContentChildrenBackground: null,
        playIcon: PaletteIconPlaySolid,
        playIconColor: '#ffffff'
      }
    },
    SplashButtonWithDetails: {
      appearances: {
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            buttonContentChildrenBackground: 'rgba(255, 255, 255, 0.8)'
          }
        }
      ],
      tokens: {
        buttonBackground: '#ffffff',
        buttonBorderColor: '#e3e6e8',
        buttonBottomPosition: 24,
        buttonContentBackground: 'rgba(0, 0, 0, 0.6)',
        buttonContentChildrenBackground: null,
        buttonLeftPosition: 24,
        buttonMinHeight: 64,
        buttonPaddingLeft: 16,
        buttonPaddingRight: 16,
        buttonRadius: 32,
        detailsContainerPadding: 8,
        labelFontName: 'HNforTELUSSA',
        labelFontWeight: '700',
        playIcon: PaletteIconPlaySolid,
        playIconColor: '#ffffff',
        playIconContainerBackground: '#2b8000'
      }
    },
    StackView: {
      appearances: {},
      rules: [],
      tokens: {
        alignItems: 'stretch',
        flexGrow: 0,
        flexShrink: 0,
        justifyContent: 'flex-start',
        width: null
      }
    },
    Status: {
      appearances: {
        inverse: {
          description: 'Inverts the status colors',
          type: 'variant',
          values: [ true ]
        },
        priority: { type: 'variant', values: [ 'default', 'low', 'high' ] },
        purpose: {
          type: 'variant',
          values: [
            'default', 'brand',
            'subtle',  'success',
            'warning', 'error',
            'offer'
          ]
        }
      },
      rules: [
        { if: { purpose: 'brand' }, tokens: { iconColor: '#4b286d' } },
        { if: { purpose: 'subtle' }, tokens: { iconColor: '#676e73' } },
        {
          if: { purpose: 'success' },
          tokens: { icon: PaletteIconStatusSuccess, iconColor: '#2b8000' }
        },
        {
          if: { purpose: 'warning' },
          tokens: { icon: PaletteIconStatusWarning, iconColor: '#c77539' }
        },
        {
          if: { purpose: 'error' },
          tokens: { icon: PaletteIconStatusError, iconColor: '#c12335' }
        },
        { if: { purpose: 'offer' }, tokens: { iconColor: '#7c53a5' } },
        {
          if: { priority: 'low' },
          tokens: {
            borderRadius: 99,
            paddingBottom: 4,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 4
          }
        },
        {
          if: { priority: 'high' },
          tokens: {
            backgroundColor: '#414547',
            borderRadius: 99,
            iconColor: '#ffffff',
            paddingBottom: 4,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 4,
            textColor: '#ffffff'
          }
        },
        {
          if: { priority: 'low', purpose: 'default' },
          tokens: { backgroundColor: '#f4f4f7' }
        },
        {
          if: { priority: 'high', purpose: 'default' },
          tokens: { backgroundColor: '#414547' }
        },
        {
          if: { priority: 'low', purpose: 'brand' },
          tokens: { backgroundColor: '#efedff' }
        },
        {
          if: { priority: 'high', purpose: 'brand' },
          tokens: { backgroundColor: '#4b286d' }
        },
        {
          if: { priority: 'low', purpose: 'subtle' },
          tokens: { backgroundColor: '#fafafa' }
        },
        {
          if: { priority: 'high', purpose: 'subtle' },
          tokens: { backgroundColor: '#676e73' }
        },
        {
          if: { priority: 'low', purpose: 'success' },
          tokens: { backgroundColor: '#f4f9f2' }
        },
        {
          if: { priority: 'high', purpose: 'success' },
          tokens: { backgroundColor: '#2b8000' }
        },
        {
          if: { priority: 'low', purpose: 'warning' },
          tokens: { backgroundColor: '#fff9ee' }
        },
        {
          if: { priority: 'high', purpose: 'warning' },
          tokens: { backgroundColor: '#c77539' }
        },
        {
          if: { priority: 'low', purpose: 'error' },
          tokens: { backgroundColor: '#fff6f8' }
        },
        {
          if: { priority: 'high', purpose: 'error' },
          tokens: { backgroundColor: '#c12335' }
        },
        {
          if: { priority: 'low', purpose: 'offer' },
          tokens: { backgroundColor: '#f4f4f7' }
        },
        {
          if: { priority: 'high', purpose: 'offer' },
          tokens: {
            backgroundGradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { inverse: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            iconColor: '#ffffff',
            textColor: '#ffffff'
          }
        },
        {
          if: { inverse: true, priority: 'low' },
          tokens: { backgroundColor: '#2c2e30' }
        },
        {
          if: { inverse: true, priority: 'high' },
          tokens: {
            backgroundColor: '#ffffff',
            iconColor: '#2c2e30',
            textColor: '#2c2e30'
          }
        }
      ],
      tokens: {
        backgroundColor: null,
        backgroundGradient: null,
        borderColor: null,
        borderRadius: null,
        borderWidth: null,
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '700',
        icon: PaletteIconStatusInfo,
        iconColor: '#414547',
        iconGradient: null,
        iconPaddingTop: 0,
        iconSize: 20,
        marginLeft: 8,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        textColor: '#676e73',
        textLineHeight: 1.14285714286
      }
    },
    StepTracker: {
      appearances: {
        inverse: {
          description: 'Styles the step tracker for using on dark backgrounds.',
          type: 'variant',
          values: [ true ]
        },
        style: { type: 'variant', values: [ 'default', 'bar' ] },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: { showStepLabel: true, showStepTrackerLabel: false }
        },
        {
          if: { inverse: true },
          tokens: {
            connectorColor: '#ffffff',
            connectorCompletedColor: '#ffffff',
            knobBackgroundColor: 'rgba(0, 0, 0, 0)',
            knobBorderColor: '#ffffff',
            knobCompletedBackgroundColor: 'rgba(0, 0, 0, 0)',
            knobCompletedBorderColor: '#ffffff',
            knobCurrentBackgroundColor: '#ffffff',
            knobCurrentBorderColor: '#ffffff',
            knobCurrentInnerColor: '#ffffff',
            labelColor: '#ffffff',
            labelCurrentColor: '#ffffff'
          }
        },
        { if: { style: 'bar' }, tokens: { barGap: 4, barHeight: 8 } }
      ],
      tokens: {
        barBackgroundColor: 'rgba(0, 0, 0, 0.1)',
        barCompletedBackgroundColor: '#613889',
        barCurrentBackgroundColor: '#613889',
        barGap: null,
        barHeight: null,
        completedIcon: null,
        completedIconColor: null,
        completedIconSize: null,
        connectorColor: '#676e73',
        connectorCompletedColor: '#7c53a5',
        connectorCompletedHeight: 3,
        connectorHeight: 1,
        connectorMinWidth: 16,
        containerPaddingBottom: null,
        containerPaddingLeft: null,
        containerPaddingRight: null,
        containerPaddingTop: null,
        knobBackgroundColor: 'rgba(0, 0, 0, 0)',
        knobBorderColor: '#676e73',
        knobBorderWidth: 1,
        knobCompletedBackgroundColor: 'rgba(0, 0, 0, 0)',
        knobCompletedBorderColor: '#7c53a5',
        knobCompletedPaddingLeft: 0,
        knobCompletedPaddingTop: 0,
        knobCurrentBackgroundColor: '#7c53a5',
        knobCurrentBorderColor: '#7c53a5',
        knobCurrentBorderWidth: 2,
        knobCurrentInnerColor: '#7c53a5',
        knobCurrentInnerSize: 8,
        knobCurrentPaddingLeft: null,
        knobCurrentPaddingTop: null,
        knobSize: 16,
        labelColor: '#414547',
        labelCurrentColor: '#4b286d',
        labelCurrentFontName: 'HNforTELUSSA',
        labelCurrentFontWeight: '700',
        labelDirection: 'column',
        labelFontName: 'HNforTELUSSA',
        labelFontSize: 14,
        labelFontWeight: '400',
        labelGap: 0,
        labelLineHeight: 1.42857142857,
        labelMarginTop: 8,
        labelPaddingLeft: 16,
        labelPaddingRight: 16,
        showStepLabel: false,
        showStepName: true,
        showStepTrackerLabel: true,
        stepLabelColor: '#676e73',
        stepLabelFontName: 'HNforTELUSSA',
        stepLabelFontSize: 12,
        stepLabelFontWeight: '700',
        stepLabelLineHeight: 1.33333333333,
        textStepTrackerLabel: 1
      }
    },
    StoryCard: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { borderWidth: 2 } },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#f4f4f7' }
        },
        {
          if: { focus: true },
          tokens: {
            outerBorderColor: '#676e73',
            outerBorderGap: 2,
            outerBorderWidth: 2
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#e3e6e8',
        borderRadius: 6,
        borderWidth: 1,
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 0,
        contentJustifyContent: 'flex-start',
        flex: 1,
        minWidth: 0,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        shadow: null
      }
    },
    TabBar: {
      appearances: {
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { pressed: true },
          tokens: { paddingBottom: 0, paddingTop: 0 }
        }
      ],
      tokens: {
        backgroundColor: '#fafafa',
        borderTopColor: '#e3e6e8',
        borderTopWidth: 1,
        gap: 8,
        paddingBottom: 4,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4
      }
    },
    TabBarItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { focus: true },
          tokens: {
            backgroundColor: '#f4f4f7',
            color: '#414547',
            iconColor: '#414547',
            iconSize: 26
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: '#4b286d',
            iconColor: '#4b286d',
            iconSize: 22
          }
        },
        { if: { hover: true }, tokens: { iconSize: 26 } }
      ],
      tokens: {
        activeColor: '#4b286d',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 4,
        color: '#676e73',
        fontName: 'HNforTELUSSA',
        fontWeight: '500',
        iconColor: '#676e73',
        iconSize: 24,
        lineHeight: 1.14285714286,
        paddingBottom: 4,
        paddingTop: 4
      }
    },
    Table: {
      appearances: {
        highlight: { type: 'variant', values: [ 'row' ] },
        spacing: {
          description: 'Adjusts the height of the table cell',
          type: 'variant',
          values: [ 'compact', 'default' ]
        },
        text: { type: 'variant', values: [ 'small', 'medium' ] },
        type: {
          type: 'variant',
          values: [ 'subHeading', 'rowHeading', 'heading', 'default' ]
        }
      },
      rules: [
        {
          if: { highlight: 'row' },
          tokens: { rowHoverBackgroundColor: 'rgba(0, 0, 0, 0.05)' }
        },
        {
          if: { spacing: 'compact', type: 'default' },
          tokens: {
            cellPaddingBottom: 8,
            cellPaddingTop: 8,
            fontSize: 16,
            lineHeight: 1.25
          }
        },
        {
          if: { spacing: 'compact', type: 'rowHeading' },
          tokens: {
            cellPaddingBottom: 8,
            cellPaddingTop: 8,
            fontName: 'HNforTELUSSA',
            fontSize: 16,
            fontWeight: '700',
            lineHeight: 1.25
          }
        },
        {
          if: { spacing: 'compact', text: 'small', type: 'subHeading' },
          tokens: {
            cellBackground: '#fafafa',
            cellPaddingBottom: 8,
            cellPaddingTop: 8,
            fontName: 'HNforTELUSSA',
            fontSize: 14,
            fontWeight: '500',
            lineHeight: 1.14285714286
          }
        },
        {
          if: { type: 'heading' },
          tokens: {
            cellBackground: '#f4f4f7',
            cellBoxShadowColor: '#b2b9bf',
            fontName: 'HNforTELUSSA',
            fontSize: 16,
            fontWeight: '500'
          }
        },
        {
          if: { spacing: 'default', type: 'subHeading' },
          tokens: {
            cellBackground: '#fafafa',
            fontName: 'HNforTELUSSA',
            fontSize: 14,
            fontWeight: '500',
            lineHeight: 1.28571428571
          }
        },
        {
          if: { spacing: 'compact', text: 'medium', type: 'subHeading' },
          tokens: {
            cellBackground: '#fafafa',
            fontName: 'HNforTELUSSA',
            fontSize: 16,
            fontWeight: '500',
            lineHeight: 1.25
          }
        },
        {
          if: { spacing: 'default', type: 'rowHeading' },
          tokens: { fontName: 'HNforTELUSSA', fontSize: 16, fontWeight: '700' }
        },
        {
          if: { spacing: 'default', text: 'small', type: 'default' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 14,
            fontWeight: '400',
            lineHeight: 1.42857142857
          }
        },
        {
          if: { spacing: 'compact', text: 'small', type: 'default' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 14,
            fontWeight: '400',
            lineHeight: 1.14285714286
          }
        },
        {
          if: { text: 'small', type: 'rowHeading' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 14,
            fontWeight: '700',
            lineHeight: 1.14285714286
          }
        }
      ],
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        cellBackground: 'rgba(0, 0, 0, 0)',
        cellBorderColor: 'rgba(0, 0, 0, 0)',
        cellBorderTopWidth: 0,
        cellBorderWidth: 0,
        cellBoxShadowColor: '#e3e6e8',
        cellMinWidth: 0,
        cellPaddingBottom: 16,
        cellPaddingLeft: 16,
        cellPaddingRight: 16,
        cellPaddingTop: 16,
        cellStickyShadow: {
          blur: 8,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: false,
          offsetX: 0,
          offsetY: 4,
          spread: 0
        },
        display: null,
        fontColor: '#000000',
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        lineHeight: 1.5,
        rowBorderColor: 'rgba(0, 0, 0, 0)',
        rowBorderTopWidth: 0,
        rowBorderWidth: 0,
        rowHoverBackgroundColor: 'rgba(0, 0, 0, 0)',
        stickyBackgroundColor: '#ffffff',
        tablePaddingBottom: 24
      }
    },
    Tabs: {
      appearances: {
        equalWidth: {
          description: 'Divide the available width equally among `TabsItem`',
          type: 'variant',
          values: [ true ]
        },
        inverse: {
          description: 'Styles the link white for use on dark backgrounds.',
          type: 'variant',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { inverse: true },
          tokens: { borderBottomColor: '#ffffff' }
        }
      ],
      tokens: {
        borderBottomColor: '#676e73',
        borderBottomWidth: 1,
        buttonClearance: 24,
        gutter: 4,
        nextIcon: PaletteIconArrowRight,
        previousIcon: PaletteIconArrowLeft,
        space: 0
      }
    },
    TabsItem: {
      appearances: {
        dropdown: {
          description: 'activate the dropdown menu',
          type: 'variant',
          values: [ true ]
        },
        equalWidth: {
          description: 'Divide the available width equally among `TabsItem`',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          description: "The design uses height of 3: there's (rightly) no '3' in the Allium palette but the effect is 1px above and below a 1px line",
          if: { selected: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            color: '#4b286d',
            highlightBarBorderRadius: 32,
            highlightBarBorderWidth: 1,
            highlightBarHeight: 1,
            highlightColor: '#4b286d'
          }
        },
        {
          if: { hover: true },
          tokens: { borderColor: '#b2b9bf', borderWidth: 2 }
        },
        {
          if: { focus: true },
          tokens: { borderColor: '#4b286d', borderWidth: 2, color: '#4b286d' }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#676e73',
            borderColor: 'transparent',
            borderWidth: 0,
            color: '#ffffff'
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { backgroundColor: '#4b286d' }
        },
        {
          if: { inverse: true },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', color: '#ffffff' }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { borderColor: '#ffffff', highlightColor: '#ffffff' }
        },
        {
          if: { inverse: true, selected: true },
          tokens: {
            backgroundColor: '#ffffff',
            color: '#414547',
            highlightColor: '#ffffff'
          }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            backgroundColor: '#ffffff',
            color: '#414547',
            highlightColor: '#ffffff'
          }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { borderColor: '#ffffff', highlightColor: '#ffffff' }
        },
        { if: { equalWidth: true }, tokens: { maxWidth: null } },
        {
          if: { dropdown: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderRadius: 32,
            borderWidth: 3,
            color: '#676e73',
            paddingHorizontal: 21,
            paddingVertical: 5
          }
        },
        {
          if: { dropdown: true, hover: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: '#ffffff',
            borderColor: '#b2b9bf',
            borderWidth: 3
          }
        },
        {
          if: { dropdown: true, focus: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            borderColor: '#4b286d',
            borderWidth: 2,
            color: '#4b286d',
            paddingHorizontal: 22,
            paddingVertical: 6
          }
        },
        {
          if: { dropdown: true, pressed: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: '#4b286d',
            borderColor: '#4b286d',
            color: '#ffffff',
            paddingHorizontal: 24,
            paddingVertical: 8
          }
        },
        {
          if: { dropdown: true, selected: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderWidth: 0,
            color: '#4b286d',
            paddingHorizontal: 24,
            paddingVertical: 8
          }
        },
        {
          if: { dropdown: true, inverse: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: '#ffffff'
          }
        },
        {
          if: {
            dropdown: true,
            hover: true,
            inverse: true,
            viewport: [ 'xs', 'sm' ]
          },
          tokens: { borderColor: '#ffffff' }
        },
        {
          if: {
            dropdown: true,
            inverse: true,
            selected: true,
            viewport: [ 'xs', 'sm' ]
          },
          tokens: { backgroundColor: '#ffffff', color: '#414547' }
        },
        {
          if: {
            dropdown: true,
            inverse: true,
            pressed: true,
            viewport: [ 'xs', 'sm' ]
          },
          tokens: { backgroundColor: '#ffffff', color: '#414547' }
        },
        {
          if: {
            dropdown: true,
            focus: true,
            inverse: true,
            viewport: [ 'xs', 'sm' ]
          },
          tokens: { borderColor: '#ffffff' }
        }
      ],
      tokens: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        borderRadius: 32,
        borderWidth: 0,
        color: '#676e73',
        dropdownIcon: PaletteIconCaretDown,
        dropdownIconExpanded: PaletteIconCaretUp,
        fontName: 'HNforTELUSSA',
        fontScaleCap: 64,
        fontSize: 14,
        fontWeight: '700',
        highlightBarBorderRadius: 0,
        highlightBarBorderWidth: 0,
        highlightBarHeight: 0,
        highlightColor: 'transparent',
        highlightTriangleSize: 0,
        letterSpacing: 0,
        lineHeight: 1.14285714286,
        marginHorizontal: 0,
        marginVertical: 0,
        maxWidth: 192,
        paddingHorizontal: 24,
        paddingVertical: 8,
        space: 1,
        textAlign: 'center',
        textTransform: 'none'
      }
    },
    Tags: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [ { if: { viewport: [ 'lg', 'xl' ] }, tokens: { space: 3 } } ],
      tokens: {
        alignItems: 'center',
        direction: 'row',
        flexGrow: 0,
        flexShrink: 0,
        justifyContent: 'flex-start',
        space: 1
      }
    },
    TagsItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#676e73',
            borderColor: '#676e73',
            borderWidth: 0,
            color: '#ffffff',
            iconBackground: '#414547',
            iconColor: '#ffffff'
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#676e73',
            outerBorderColor: '#676e73',
            outerBorderGap: 2,
            outerBorderWidth: 2
          }
        },
        { if: { hover: true }, tokens: { borderWidth: 3 } },
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#4b286d',
            borderWidth: 0,
            color: '#ffffff',
            icon: PaletteIconClose,
            iconBackground: '#7c53a5',
            iconColor: '#ffffff'
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: { backgroundColor: '#7c53a5', iconBackground: '#4b286d' }
        },
        {
          if: { pressed: true, selected: true },
          tokens: { backgroundColor: '#3f2a54', iconBackground: '#7c53a5' }
        },
        {
          if: { focus: true, selected: true },
          tokens: { outerBorderColor: '#4b286d' }
        },
        {
          if: { focus: true, pressed: true, selected: true },
          tokens: { iconBackground: '#7c53a5', outerBorderColor: '#3f2a54' }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#ffffff',
            borderWidth: 0,
            color: '#b2b9bf',
            iconBackground: '#f4f4f7',
            iconColor: '#b2b9bf'
          }
        }
      ],
      tokens: {
        alignSelf: 'center',
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderRadius: 32,
        borderWidth: 1,
        color: '#676e73',
        fontName: 'HNforTELUSSA',
        fontSize: 14,
        fontWeight: '700',
        icon: PaletteIconAdd,
        iconAlignSelf: 'center',
        iconBackground: '#f4f4f7',
        iconBorderRadius: 32,
        iconColor: '#2c2e30',
        iconPadding: 2,
        iconPosition: 'right',
        iconSize: 16,
        iconSpace: 2,
        iconTranslateX: 0,
        iconTranslateY: 0,
        lineHeight: 1.42857142857,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderWidth: 2,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 8,
        paddingTop: 8,
        shadow: null,
        textAlign: 'center'
      }
    },
    TermsAndConditions: {
      appearances: {
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            expandContentPaddingRight: 24,
            listMarginLeft: 6,
            titlePaddingLeft: 6
          }
        },
        {
          if: { expanded: true },
          tokens: { icon: PaletteIconCaretUp }
        },
        {
          if: { focus: true },
          tokens: {
            iconOuterBorderColor: '#414547',
            iconOuterBorderGap: 4,
            iconOuterBorderWidth: 1
          }
        },
        {
          if: { pressed: true },
          tokens: {
            iconBackgroundColor: '#676e73',
            iconBorderColor: '#ffffff',
            iconColor: '#ffffff',
            iconOuterBorderGap: 4
          }
        }
      ],
      tokens: {
        contentBorderColor: 'transparent',
        contentMarginBottom: 0,
        contentPaddingBottom: 0,
        contentPaddingLeft: 16,
        dividerColor: '#b2b9bf',
        expandBaseBorderWidth: 0,
        expandContentPaddingBottom: 16,
        expandContentPaddingLeft: 16,
        expandContentPaddingRight: 16,
        expandContentPaddingTop: 16,
        expandIconContainerAlignItems: 'center',
        expandIconContainerBorder: 0,
        expandIconContainerBorderColor: 'rgba(0, 0, 0, 0)',
        expandIconContainerHeight: 32,
        expandIconContainerJustifyContent: 'center',
        expandIconContainerMarginX: 0,
        expandIconContainerMarginY: 12,
        expandIconContainerWidth: 32,
        expandTitleBorder: 0,
        expandTitleBorderColor: 'rgba(0, 0, 0, 0)',
        expandTitleColor: '#2c2e30',
        expandTitleFontName: 'HNforTELUSSA',
        expandTitleFontSize: 16,
        expandTitleFontWeight: '500',
        expandTitleLineHeight: 1.5,
        expandTitleMarginX: 4,
        expandTitleMarginY: 0,
        expandTitlePaddingLeft: 0,
        expandTitleUnderline: 'none',
        headerBackgroundColor: 'rgba(0, 0, 0, 0)',
        icon: PaletteIconCaretDown,
        iconBackgroundColor: 'transparent',
        iconBorderColor: '#676e73',
        iconColor: '#676e73',
        iconOuterBorderColor: 'transparent',
        iconOuterBorderGap: 0,
        iconOuterBorderWidth: null,
        listColor: '#414547',
        listFontName: 'HNforTELUSSA',
        listFontSize: 14,
        listFontWeight: '400',
        listLineHeight: 1.42857142857,
        listMarginBottom: 16,
        listMarginLeft: 32,
        mdContentPaddingBottom: 16,
        mdContentPaddingLeft: 48,
        orderedPadding: 0,
        titleColor: '#414547',
        titleFontSize: 14,
        titleLineHeight: 1.42857142857,
        titlePaddingLeft: 32,
        unorderedPadding: 12
      }
    },
    Testimonial: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            testimonialFontNameHeading: 'HNforTELUSSA',
            testimonialFontSizeHeading: 28,
            testimonialFontWeightHeading: '400',
            testimonialLineHeightHeading: 1.28571428571
          }
        }
      ],
      tokens: {
        additionalFontName: 'HNforTELUSSA',
        additionalFontSize: 14,
        additionalFontWeight: '400',
        additionalLineHeight: 1.42857142857,
        authorFontName: 'HNforTELUSSA',
        authorFontSize: 16,
        authorFontWeight: '700',
        authorLineHeight: 1.5,
        dividerBackgroundColor: '#b2b9bf',
        dividerBorder: 1,
        figcaptionGap: 12,
        icon: PaletteIconQuoteLeft,
        iconColor: '#b2b9bf',
        iconFr: PaletteIconQuoteLeftArrow,
        imageSize: 48,
        quoteContainerGap: 4,
        testimonialContainerGap: 12,
        testimonialFontNameHeading: 'HNforTELUSSA',
        testimonialFontNameLarge: 'HNforTELUSSA',
        testimonialFontSizeHeading: 24,
        testimonialFontSizeLarge: 20,
        testimonialFontWeightHeading: '400',
        testimonialFontWeightLarge: '400',
        testimonialLineHeightHeading: 1.33333333333,
        testimonialLineHeightLarge: 1.6,
        textColor: '#414547'
      }
    },
    TextArea: {
      appearances: {},
      rules: [],
      tokens: { maxLines: 8, minLines: 5 }
    },
    TextInput: {
      appearances: {
        focus: {
          description: 'Focus states for some input elements are well supported across web, RN, ios and android',
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        numeric: {
          description: 'capability to only allow numbers',
          type: 'variant',
          values: [ true ]
        },
        password: {
          description: 'capability that helps masking and unmasking text',
          type: 'variant',
          values: [ true ]
        },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        }
      },
      rules: [
        {
          if: { hover: true, inactive: null },
          tokens: {
            outerBackgroundColor: '#e3e6e8',
            outerBorderColor: '#e3e6e8'
          }
        },
        {
          if: { validation: 'success' },
          tokens: {
            borderColor: '#2b8000',
            icon: PaletteIconStatusSuccess,
            iconColor: '#2b8000'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            borderColor: '#e12339',
            icon: PaletteIconStatusError,
            iconColor: '#e12339'
          }
        },
        {
          if: { focus: true },
          tokens: { borderColor: '#7c53a5', borderWidth: 3, icon: null }
        },
        {
          if: { inactive: true },
          tokens: { backgroundColor: '#f4f4f7', borderColor: '#f4f4f7' }
        }
      ],
      tokens: {
        amexIcon: PaletteIconAmex,
        backgroundColor: '#ffffff',
        borderColor: '#676e73',
        borderRadius: 4,
        borderWidth: 1,
        buttonSize: 32,
        buttonsGap: 1,
        buttonsPaddingRight: 8,
        clearButtonIcon: PaletteIconTimes,
        color: '#414547',
        defaultCreditIcon: PaletteIconCreditCard,
        fontName: 'HNforTELUSSA',
        fontSize: 16,
        fontWeight: '400',
        icon: null,
        iconColor: 'rgba(0, 0, 0, 0)',
        iconLeftGap: 8,
        iconLeftPaddingBottom: 14,
        iconSize: 24,
        leftIconPaddingBottom: 8,
        lineHeight: 1.5,
        masterCardIcon: PaletteIconMasterCard,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        passwordHideButtonIcon: PaletteIconInvisible,
        passwordShowButtonIcon: PaletteIconVisible,
        visaIcon: PaletteIconVisa
      }
    },
    Timeline: {
      appearances: {
        horizontal: {
          description: 'Use horizontal to display timeline horizontally.',
          type: 'variant',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { horizontal: true, viewport: [ 'lg', 'xl' ] },
          tokens: {
            connectorHeight: 1,
            connectorWidth: '100%',
            itemContentMarginBottom: 0,
            itemContentMarginRight: 32,
            lineItemContainerDirection: 'column',
            lineItemDirection: 'row',
            lineItemMarginBottom: 24,
            lineItemMarginRight: 0,
            timelineContainerDirection: 'row'
          }
        }
      ],
      tokens: {
        connectorHeight: '100%',
        connectorWidth: 1,
        dotBorderWidth: 1,
        dotColor: '#ffffff',
        dotWidth: 14,
        itemContentFlexSize: 1,
        itemContentMarginBottom: 32,
        itemContentMarginRight: 0,
        lineContainerFlexSize: 1,
        lineItemAlign: 'center',
        lineItemContainerDirection: 'row',
        lineItemDirection: 'column',
        lineItemMarginBottom: 0,
        lineItemMarginRight: 24,
        timelineColor: '#676e73',
        timelineConnectorColor: '#676e73',
        timelineContainerDirection: 'column'
      }
    },
    Toast: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            animationPaddingBottomAfter: 8,
            animationPaddingTopAfter: 8
          }
        }
      ],
      tokens: {
        animationBackgroundColorAfter: '#f4f4f7',
        animationBackgroundColorBefore: '#4b286d',
        animationColorAfter: '#414547',
        animationColorBefore: '#ffffff',
        animationDivColorAfter: '#2b8000',
        animationDivColorBefore: '#ffffff',
        animationHeightAfter: 24,
        animationHeightBefore: 0,
        animationPaddingBottomAfter: 16,
        animationPaddingBottomBefore: 0,
        animationPaddingTopAfter: 16,
        animationPaddingTopBefore: 0,
        chevronlinkFontName: 'HNforTELUSSA',
        chevronlinkFontWeight: '400',
        containerBackgroundColor: '#4b286d',
        containerGap: 10,
        padding: 16
      }
    },
    ToggleSwitch: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { backgroundColor: '#414547' } },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#2c2e30' }
        },
        {
          if: { focus: true },
          tokens: {
            outerBorderColor: '#676e73',
            outerBorderGap: 3,
            outerBorderWidth: 2
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: {
            outerBorderColor: '#2c2e30',
            outerBorderGap: 3,
            outerBorderWidth: 2
          }
        },
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#2b8000',
            icon: PaletteIconCheckbold,
            iconColor: '#2b8000'
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: { backgroundColor: '#1f5c09', iconColor: '#1f5c09' }
        },
        {
          if: { pressed: true, selected: true },
          tokens: { backgroundColor: '#163e06', iconColor: '#163e06' }
        },
        {
          if: { focus: true, selected: true },
          tokens: { outerBorderColor: '#676e73', outerBorderWidth: 2 }
        },
        {
          if: { focus: true, pressed: true, selected: true },
          tokens: { outerBorderColor: '#163e06', outerBorderWidth: 2 }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#b2b9bf',
            iconColor: '#b2b9bf',
            labelColor: '#b2b9bf',
            outerBorderColor: '#b2b9bf'
          }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#676e73',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        borderWidth: 0,
        containerWidth: null,
        icon: null,
        iconColor: '#676e73',
        iconSize: 14,
        labelColor: '#414547',
        labelFontName: 'HNforTELUSSA',
        labelFontSize: 16,
        labelFontWeight: '400',
        labelLineHeight: 1.5,
        labelMarginLeft: 0,
        mobileSwitchSize: 24,
        mobileTrackBorderWidth: 4,
        mobileTrackHeight: 32,
        mobileWidth: 48,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderGapButton: 3,
        outerBorderWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: true,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        },
        space: 2,
        switchBorderColor: 'rgba(0, 0, 0, 0)',
        switchBorderRadius: 32,
        switchBorderWidth: 0,
        switchColor: '#ffffff',
        switchShadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.2)',
          inset: false,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        },
        switchSize: 18,
        trackBorderColor: 'rgba(0, 0, 0, 0)',
        trackBorderRadius: 32,
        trackBorderWidth: 3,
        trackHeight: 24,
        width: 40
      }
    },
    ToggleSwitchGroup: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [ { if: { viewport: [ 'lg', 'xl' ] }, tokens: { space: 3 } } ],
      tokens: {
        alignItems: 'flex-start',
        direction: 'column',
        fieldSpace: 2,
        flexGrow: 0,
        flexShrink: 0,
        justifyContent: 'flex-start',
        space: 1
      }
    },
    Tooltip: {
      appearances: { inverse: { type: 'variant', values: [ true ] } },
      rules: [
        {
          if: { inverse: true },
          tokens: { backgroundColor: '#ffffff', color: '#414547' }
        }
      ],
      tokens: {
        arrowBorderRadius: 1,
        arrowOffset: 4,
        arrowWidth: 16,
        backgroundColor: '#2c2e30',
        borderRadius: 8,
        color: '#ffffff',
        fontName: 'HNforTELUSSA',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 1.5,
        maxWidth: 288,
        minWidth: 0,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        shadow: {
          blur: 8,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: false,
          offsetX: 0,
          offsetY: 4,
          spread: 0
        }
      }
    },
    TooltipButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        { if: { inverse: true }, tokens: { iconColor: '#ffffff' } },
        { if: { hover: true }, tokens: { iconScale: 1.25 } },
        { if: { pressed: true }, tokens: { iconColor: '#676e73' } },
        {
          if: { inverse: true, pressed: true },
          tokens: { iconColor: '#b2b9bf' }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#676e73' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { outerBorderColor: '#b2b9bf' }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        icon: PaletteIconQuestion,
        iconColor: '#2c2e30',
        iconScale: 1,
        iconSize: 16,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 4,
        outerBorderWidth: 1,
        width: 16
      }
    },
    Typography: {
      appearances: {
        bold: {
          description: 'Sets the font weight, to bold on some body text styles. Does not change accessibility properties.',
          type: 'variant',
          values: [ true ]
        },
        colour: {
          description: 'Each typography variant has a default color, and at least a secondary color variant. In exceptional cases where a different colour is needed,\n' +
            '  use the tokens prop.',
          type: 'variant',
          values: [
            'default',      'brand',
            'dark',         'light',
            'positive',     'warning',
            'danger',       'black',
            'white',        'brand2',
            'brand3',       'alternative1',
            'alternative2', 'alternative3'
          ]
        },
        compact: {
          description: 'Reduces line height on some body text styles. For data-rich content, not for flow content',
          type: 'variant',
          values: [ true ]
        },
        inverse: {
          description: 'Styles the link white for use on dark backgrounds.',
          type: 'variant',
          values: [ true ]
        },
        size: {
          description: 'Styles text as body or heading text with a given size. Smaller numbers indicate larger sizes,\n' +
            '"display" headings are larger than "h" headings. Default is medium size body text. Does not change\n' +
            'accessibility or SEO-related properties; use the heading prop if text should be treated semantically as a heading.',
          type: 'variant',
          values: [
            'micro',    'small',
            'large',    'eyebrow',
            'h1',       'h2',
            'h3',       'h4',
            'h5',       'h6',
            'display1', 'display2'
          ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        weight: {
          description: 'Sets the font weight, default is regular 400 weight. Does not change accessibility properties.',
          type: 'variant',
          values: [ 'semibold', 'bold' ]
        }
      },
      rules: [
        {
          if: { size: [ 'display1', 'display2', 'h1', 'h2', 'h3' ] },
          tokens: { color: '#4b286d' }
        },
        {
          if: {
            colour: 'dark',
            size: [ 'display1', 'display2', 'h1', 'h2', 'h3' ]
          },
          tokens: { color: '#2c2e30' }
        },
        {
          if: { colour: 'light', size: 'h6' },
          tokens: { color: '#676e73' }
        },
        {
          if: { colour: 'dark', size: 'eyebrow' },
          tokens: { color: '#7c53a5' }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          if: { size: 'display1' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 40,
            fontWeight: '300',
            letterSpacing: 0,
            lineHeight: 1.2,
            superScriptFontSize: 24
          }
        },
        {
          if: { size: 'display1', viewport: [ 'lg', 'xl' ] },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 64,
            fontWeight: '300',
            lineHeight: 1.2,
            superScriptFontSize: 32
          }
        },
        {
          if: { size: 'display2' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 36,
            fontWeight: '300',
            letterSpacing: 0,
            lineHeight: 1.22222222222,
            superScriptFontSize: 24
          }
        },
        {
          if: { size: 'display2', viewport: [ 'lg', 'xl' ] },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 56,
            fontWeight: '300',
            lineHeight: 1.14285714286,
            superScriptFontSize: 32
          }
        },
        {
          if: { size: 'h1' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 28,
            fontWeight: '300',
            letterSpacing: 0,
            lineHeight: 1.22222222222,
            superScriptFontSize: 20
          }
        },
        {
          if: { size: 'h1', viewport: [ 'lg', 'xl' ] },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 40,
            fontWeight: '300',
            letterSpacing: 0,
            lineHeight: 1.2,
            superScriptFontSize: 24
          }
        },
        {
          if: { size: 'h2' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 24,
            fontWeight: '300',
            letterSpacing: 0,
            lineHeight: 1.2,
            superScriptFontSize: 16
          }
        },
        {
          if: { size: 'h2', viewport: [ 'lg', 'xl' ] },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 28,
            fontWeight: '300',
            letterSpacing: -0.017,
            lineHeight: 1.22222222222,
            superScriptFontSize: 20
          }
        },
        {
          if: { size: 'h3' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 20,
            fontWeight: '500',
            letterSpacing: 0,
            lineHeight: 1.2,
            superScriptFontSize: 16
          }
        },
        {
          if: { size: 'h4' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 16,
            fontWeight: '500',
            letterSpacing: 0,
            lineHeight: 1.5,
            superScriptFontSize: 16
          }
        },
        {
          if: { size: 'h5' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 14,
            fontWeight: '500',
            letterSpacing: 0,
            lineHeight: 1.28571428571
          }
        },
        {
          if: { size: [ 'h5', 'h6' ] },
          tokens: { superScriptFontSize: 12 }
        },
        {
          if: { size: 'h6' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 12,
            fontWeight: '700',
            letterSpacing: 0,
            lineHeight: 1.33333333333
          }
        },
        {
          if: { size: 'large' },
          tokens: { fontSize: 20, lineHeight: 1.6, superScriptFontSize: 16 }
        },
        {
          if: { compact: true, size: 'large' },
          tokens: { lineHeight: 1.2 }
        },
        {
          description: "The compact line height for the 'default' font size, but doesn't apply for any other styles",
          if: { compact: true, size: null },
          tokens: { lineHeight: 1.25 }
        },
        {
          if: { size: 'small' },
          tokens: {
            fontSize: 14,
            lineHeight: 1.42857142857,
            superScriptFontSize: 12
          }
        },
        {
          if: { compact: true, size: 'small' },
          tokens: { lineHeight: 1.14285714286 }
        },
        {
          if: { size: 'micro' },
          tokens: {
            fontName: 'HNforTELUSSA',
            fontSize: 12,
            fontWeight: '500',
            lineHeight: 1.33333333333,
            superScriptFontSize: 12
          }
        },
        {
          if: { size: 'eyebrow' },
          tokens: {
            color: '#7c53a5',
            fontName: 'HNforTELUSSA',
            fontSize: 14,
            fontWeight: '700',
            lineHeight: 1.42857142857,
            textTransform: 'uppercase'
          }
        },
        {
          description: 'Please only bold single words while using with headings',
          if: { bold: true },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        {
          if: { bold: true, size: 'micro' },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        {
          if: { bold: true, size: 'display1' },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        {
          if: { bold: true, size: 'display2' },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        {
          if: { bold: true, size: 'h1' },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        {
          if: { bold: true, size: 'h2' },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        {
          if: { bold: true, size: 'h3' },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        {
          if: {
            bold: true,
            size: [ 'h4', 'h5', 'h6' ],
            viewport: [ 'xs', 'sm', 'md' ]
          },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        {
          if: { weight: 'semibold' },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '500' }
        },
        {
          if: { weight: 'bold' },
          tokens: { fontName: 'HNforTELUSSA', fontWeight: '700' }
        },
        { if: { colour: 'default' }, tokens: { color: '#414547' } },
        { if: { colour: 'brand' }, tokens: { color: '#4b286d' } },
        { if: { colour: 'dark' }, tokens: { color: '#2c2e30' } },
        { if: { colour: 'light' }, tokens: { color: '#676e73' } },
        { if: { colour: 'positive' }, tokens: { color: '#2b8000' } },
        { if: { colour: 'warning' }, tokens: { color: '#c77539' } },
        { if: { colour: 'danger' }, tokens: { color: '#c12335' } },
        { if: { colour: 'black' }, tokens: { color: '#000000' } },
        { if: { colour: 'white' }, tokens: { color: '#ffffff' } },
        { if: { colour: 'brand2' }, tokens: { color: '#2b8000' } },
        { if: { colour: 'brand3' }, tokens: { color: '#7c53a5' } },
        {
          if: { colour: 'alternative1' },
          tokens: {
            color: '#4b286d',
            gradient: {
              angle: 135,
              stops: [
                { color: '#4b286d', hint: 0.75, stop: 0 },
                { color: '#e53293', stop: 1 }
              ],
              type: 'linear'
            }
          }
        },
        {
          if: { colour: 'alternative2' },
          tokens: { color: '#4b286d' }
        },
        {
          if: { colour: 'alternative3' },
          tokens: { color: '#4b286d' }
        }
      ],
      tokens: {
        color: '#414547',
        fontName: 'HNforTELUSSA',
        fontScaleCap: 64,
        fontSize: 16,
        fontWeight: '400',
        gradient: null,
        letterSpacing: 0,
        lineHeight: 1.5,
        superScriptFontSize: 16,
        textTransform: 'none'
      }
    },
    Video: {
      appearances: {},
      rules: [],
      tokens: {
        borderColor: '#b2b9bf',
        pauseIcon: PaletteIconPause,
        playIcon: PaletteIconPlaySolid,
        replayIcon: PaletteIconReplay
      }
    },
    VideoButton: { appearances: {}, rules: [], tokens: { color: '#ffffff' } },
    VideoControlBar: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            height: 40,
            paddingBottom: 16,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 16
          }
        }
      ],
      tokens: {
        captionsIcon: PaletteIconClosedCaptions,
        height: 56,
        maximizeIcon: PaletteIconFullscreenExpand,
        menuBottom: 64,
        menuMarginLeft: 16,
        menuRight: 32,
        minimizeIcon: PaletteIconFullscreenMinimize,
        paddingBottom: 16,
        paddingLeft: 48,
        paddingRight: 48,
        paddingTop: 16,
        settingsIcon: PaletteIconSettingsSolid
      }
    },
    VideoMenu: {
      appearances: {},
      rules: [],
      tokens: {
        background: '#2c2e30',
        checkMarkFocusColor: '#676e73',
        checkMarkHeight: 24,
        checkMarkHoverColor: '#676e73',
        checkMarkIcon: PaletteIconCheckbold,
        checkMarkSelectedColor: '#ffffff',
        checkMarkUnselectedColor: 'rgba(0, 0, 0, 0)',
        checkMarkWidth: 24,
        padding: 16
      }
    },
    VideoMiddleControlButton: {
      appearances: {},
      rules: [],
      tokens: {
        background: '#2c2e30',
        height: 64,
        iconColor: '#ffffff',
        width: 64
      }
    },
    VideoPicker: {
      appearances: {},
      rules: [],
      tokens: {
        framedContainerBackgroundColor: '#fafafa',
        framedContainerBorderColor: '#e3e6e8',
        framedContainerBorderRadius: 4,
        framedContainerBorderWidth: 1,
        framedContainerPadding: 24,
        framedMaxHeight: 640,
        stackViewDividerColor: '#e3e6e8'
      }
    },
    VideoPickerSlider: {
      appearances: {},
      rules: [],
      tokens: {
        nextIcon: PaletteIconArrowRight,
        previousIcon: PaletteIconArrowLeft
      }
    },
    VideoPickerThumbnail: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { focus: true },
          tokens: { borderColor: '#b2b9bf', outerBorderColor: '#b2b9bf' }
        },
        {
          if: { hover: true },
          tokens: { borderColor: '#e3e6e8', borderWidth: 3 }
        },
        {
          if: { pressed: true },
          tokens: { borderColor: '#676e73', borderWidth: 3 }
        },
        {
          if: { selected: true },
          tokens: {
            borderColor: '#4b286d',
            borderWidth: 2,
            titleColor: '#4b286d'
          }
        }
      ],
      tokens: {
        borderColor: '#e3e6e8',
        borderRadius: 4,
        borderWidth: 2,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderRadius: 8,
        outerBorderWidth: 2,
        pressableBorderTopColor: '#e3e6e8',
        pressableBorderTopWidth: 1,
        pressablePaddingBottom: 16,
        pressablePaddingHorizontal: 24,
        pressablePaddingVertical: 16,
        splashButtonRadius: 4,
        subTitleColor: '#676e73',
        titleColor: '#414547'
      }
    },
    VideoProgressBar: {
      appearances: {},
      rules: [],
      tokens: {
        rangeBackground: 'rgba(0, 0, 0, 0)',
        remainingTimestampMarginLeft: 8,
        remainingTimestampMarginRight: 0,
        thumbBackground: '#ffffff',
        thumbHeight: 8,
        thumbWidth: 8,
        timestampMarginLeft: 0,
        timestampMarginRight: 8,
        trackGradientEnd: '#66cc00',
        trackGradientStart: '#66cc00'
      }
    },
    VideoVolumeSlider: {
      appearances: {},
      rules: [],
      tokens: {
        marginLeft: 16,
        marginRight: 16,
        mutedIcon: PaletteIconMuted,
        rangeBackground: 'rgba(0, 0, 0, 0)',
        thumbBackground: '#ffffff',
        thumbHeight: 8,
        thumbWidth: 8,
        trackGradientEnd: '#ffffff',
        trackGradientStart: '#ffffff',
        unmutedIcon: PaletteIconUnmuted
      }
    },
    WaffleGrid: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        { if: { viewport: [ 'xs' ] }, tokens: { rowSize: 2 } },
        { if: { viewport: [ 'sm', 'md' ] }, tokens: { rowSize: 3 } },
        { if: { viewport: [ 'lg', 'xl' ] }, tokens: { rowSize: 6 } }
      ],
      tokens: {
        itemBorderColor: '#b2b9bf',
        itemPadding: 16,
        rowBorderWidth: 1,
        rowSize: 6
      }
    },
    spacingScale: {
      appearances: {
        space: {
          description: 'Index of the intended position on the spacing scale',
          type: 'state',
          values: [
             0, 1, 2, 3,  4,  5,
             6, 7, 8, 9, 10, 11,
            12
          ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        { if: { viewport: [ 'lg', 'xl' ] }, tokens: { size: 120 } },
        { if: { space: 11 }, tokens: { size: 96 } },
        { if: { space: 12 }, tokens: { size: 120 } },
        { if: { space: 10 }, tokens: { size: 80 } },
        { if: { space: 9 }, tokens: { size: 64 } },
        { if: { space: 8 }, tokens: { size: 48 } },
        { if: { space: 7 }, tokens: { size: 40 } },
        { if: { space: 6 }, tokens: { size: 36 } },
        { if: { space: 5 }, tokens: { size: 32 } },
        { if: { space: 4 }, tokens: { size: 24 } },
        { if: { space: 3 }, tokens: { size: 16 } },
        { if: { space: 2 }, tokens: { size: 8 } },
        { if: { space: 1 }, tokens: { size: 4 } },
        {
          if: { space: 11, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 120 }
        },
        {
          if: { space: 10, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 96 }
        },
        {
          if: { space: 9, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 72 }
        },
        {
          if: { space: 8, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 64 }
        },
        {
          if: { space: 7, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 48 }
        },
        {
          if: { space: 6, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 40 }
        },
        { if: { space: 0 }, tokens: { size: 0 } }
      ],
      tokens: { size: 96 }
    }
  },
  metadata: { name: 'theme-allium', themeTokensVersion: '4.15.1' }
}
export default theme
